import { Fragment as e, computed as t, createBlock as n, createCommentVNode as r, createElementBlock as i, createElementVNode as a, createSlots as o, createTextVNode as s, createVNode as c, defineComponent as l, inject as u, isRef as d, markRaw as f, mergeProps as p, nextTick as m, normalizeClass as h, normalizeStyle as g, onBeforeMount as _, onBeforeUnmount as v, onMounted as ee, onUnmounted as y, openBlock as b, provide as x, ref as S, renderList as C, renderSlot as w, resolveDynamicComponent as T, toDisplayString as E, toRaw as D, toRef as O, unref as k, useSlots as A, useTemplateRef as te, vShow as j, watch as M, withCtx as N, withDirectives as P } from "vue";
import { BBadge as F, BButton as I, BButtonGroup as L, BCard as R, BFormCheckbox as z, BFormCheckboxGroup as ne, BFormFile as re, BFormGroup as ie, BFormInput as ae, BFormRadioGroup as oe, BFormSelect as se, BFormTags as ce, BFormTextarea as le, BInputGroup as ue, BInputGroupText as de, BModal as fe, BPopover as pe, BSpinner as me } from "bootstrap-vue-next";
import { createPinia as he, defineStore as ge, getActivePinia as _e, setActivePinia as ve, storeToRefs as B } from "pinia";
import { v4 as ye } from "uuid";
import be from "json-pointer";
import { EmptyValidator as xe, keywords as Se } from "@educorvi/vue-json-form-schemas";
import Ce from "deepmerge";
import we from "fast-deep-equal";
import { Atom as Te, HasNoLengthError as Ee, Parser as De, RitaError as Oe, UndefinedPathError as ke, getAtoms as Ae } from "@educorvi/rita";
import { Decimal as je } from "decimal.js";
import Me from "sanitize-html";
import { watchDebounced as Ne } from "@vueuse/core";
import { VueDraggable as Pe } from "vue-draggable-plus";
import "vue-component-type-helpers";
//#region \0rolldown/runtime.js
var Fe = Object.defineProperty, V = (e, t) => {
	let n = {};
	for (var r in e) Fe(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || Fe(n, Symbol.toStringTag, { value: "Module" }), n;
}, Ie = /* @__PURE__ */ l({
	__name: "ArrayButton",
	props: {
		disabled: { type: Boolean },
		ariaLabel: {},
		variant: {}
	},
	emits: ["click"],
	setup(e, { emit: t }) {
		let r = e, i = t;
		return (e, t) => (b(), n(k(I), {
			variant: r.variant,
			disabled: r.disabled,
			"aria-label": r.ariaLabel,
			onClick: t[0] ||= (e) => i("click")
		}, {
			default: N(() => [w(e.$slots, "default")]),
			_: 3
		}, 8, [
			"variant",
			"disabled",
			"aria-label"
		]));
	}
}), Le = {
	key: 0,
	class: "vjf_showOnWrapper"
}, Re = /* @__PURE__ */ l({
	__name: "showOnWrapper",
	props: { visible: { type: Boolean } },
	setup(e) {
		return (t, n) => e.visible ? (b(), i("div", Le, [w(t.$slots, "default")])) : r("", !0);
	}
}), ze = { class: "wrappers-parent" }, Be = { class: "stepWrapper" }, Ve = { class: "d-flex justify-content-between" }, He = ["disabled", "onClick"], Ue = { class: "stepWrapperBg" }, We = { class: "d-flex justify-content-between" }, Ge = /*@__PURE__*/ l({
	__name: "WizardProgress",
	props: {
		numberOfPages: {},
		pageNames: {},
		currentStep: {}
	},
	emits: ["update:currentStep"],
	setup(t, { emit: n }) {
		let r = t, o = n;
		function s(e) {
			let t = e - 1;
			t < r.currentStep && o("update:currentStep", t);
		}
		return M(() => r.currentStep, () => {
			document.querySelectorAll(".wrappers-parent").forEach((e) => {
				let t = e.querySelector(".custom-wizard-progress"), n = e.querySelectorAll(".stepWrapper .stepNumber");
				if (!t || n.length < 2) return;
				let i = n[0], a = n[n.length - 1];
				if (!i || !a) return;
				let o = i.offsetLeft + i.offsetWidth / 2, s = a.offsetLeft + a.offsetWidth / 2 - o, c = (o + r.currentStep / (n.length - 1) * s) / t.offsetWidth * 100;
				t.style.setProperty("--progress", `${c}%`);
			});
		}, { immediate: !0 }), (n, o) => (b(), i("div", ze, [
			a("div", Be, [a("div", Ve, [(b(!0), i(e, null, C(Array.from({ length: r.numberOfPages }, (e, t) => t + 1), (e) => (b(), i("div", {
				key: "wizard-fg-" + e,
				class: h({
					"stepNumber d-flex justify-content-center align-items-center": !0,
					active: e - 1 === t.currentStep,
					filled: e - 1 < t.currentStep
				})
			}, [a("button", {
				disabled: e > t.currentStep,
				class: "fs-4",
				onClick: () => s(e)
			}, E(e), 9, He)], 2))), 128))])]),
			o[0] ||= a("div", { class: "custom-wizard-progress" }, null, -1),
			a("div", Ue, [a("div", We, [(b(!0), i(e, null, C(Array.from({ length: r.numberOfPages }, (e, t) => t + 1), (e) => (b(), i("div", {
				key: "wizard-bg-" + e,
				class: h({
					"stepNumber d-flex justify-content-center align-items-center": !0,
					active: e - 1 === t.currentStep,
					filled: e - 1 < t.currentStep
				})
			}, null, 2))), 128))])])
		]));
	}
}), H = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, Ke = /*#__PURE__*/ H(Ge, [["__scopeId", "data-v-04553480"]]), qe = /* @__PURE__ */ V({
	descendantControlOverridesProviderKey: () => $e,
	formIdProviderKey: () => Je,
	formStructureProviderKey: () => Ye,
	inArrayItemProviderKey: () => et,
	languageProviderKey: () => U,
	mergeDescendantControlOptionsOverrides: () => rt,
	requiredProviderKey: () => Xe,
	savePathOverrideProviderKey: () => Ze,
	savePathProviderKey: () => Qe,
	setDescendantControlOverride: () => nt,
	setDescendantControlOverrides: () => tt
}), Je = Symbol(), Ye = Symbol(), Xe = Symbol(), Ze = Symbol(), Qe = Symbol(), $e = Symbol(), U = Symbol(), et = Symbol();
function tt(e) {
	if (e) for (let [t, n] of Object.entries(e)) nt(t, n);
}
function nt(e, t) {
	let n = u($e);
	n ||= {};
	let r = n[e];
	r ? n[e] = {
		showOn: t.showOn || r.showOn,
		options: {
			...r.options,
			...t.options
		}
	} : n[e] = t, x($e, n);
}
function rt(e, t) {
	if (!t) return e;
	let n = t[Y(e.scope)];
	return n ? {
		...e,
		options: {
			...e.options,
			...n.options
		},
		showOn: n.showOn || e.showOn
	} : e;
}
//#endregion
//#region src/Commons.ts
var it = "vjf_array-item_", at = "2.2";
function ot(e) {
	if (e.version?.split?.(".")?.length !== 2) return !1;
	let [t, n] = e.version.split(".").map(Number), [r, i] = "2.2".split(".").map(Number);
	return !(t !== r || (n ?? 2 ** 53 - 1) > (i ?? 0));
}
function st() {
	let e;
	try {
		e = crypto.randomUUID();
	} catch {
		console.warn("crypto.randomUUID() not available, using uuidv4 instead"), e = ye();
	}
	return e;
}
function ct(e) {
	return typeof e == "string" ? e.match(RegExp(`^${it}[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$`)) !== null : !1;
}
function lt(e, t) {
	return `${e}.${t}`;
}
function W(e, t) {
	return e.split("/").slice(0, t).join("/");
}
function ut(e) {
	return e?.split("/").pop();
}
function dt(e) {
	return e.map((e) => ({
		...e,
		uuid: st()
	}));
}
function ft(e, t = {}) {
	let n = {
		version: "2.2",
		layout: {
			type: t.layoutType ?? "VerticalLayout",
			options: {
				label: "groupLabel" in t ? t.groupLabel : void 0,
				description: "groupDescription" in t ? t.groupDescription : void 0
			},
			elements: []
		}
	};
	for (let r in e.properties) {
		let e = {
			type: "Control",
			scope: `${t.scopeBase ?? ""}/properties/${r}`
		};
		n.layout.elements.push(e);
	}
	return n;
}
function pt(e, t, n = ".", r) {
	if (e === void 0) {
		if (r !== void 0) return r;
		throw Error("Undefined path in data: " + t);
	}
	t = t.replace(/\[(\w+)]/g, `${n}$1`), t = t.replace(RegExp(`^${((e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))(n)}`), "");
	let i = t.split(n), a = e;
	for (let e = 0, n = i.length; e < n; ++e) {
		let n = i[e];
		if (n === void 0) {
			if (r !== void 0) return r;
			throw Error("Undefined path in data: " + t);
		}
		if (typeof a != "object" || !a) {
			if (r !== void 0) return r;
			throw Error("Invalid path in data: " + t + " is of invalid type " + typeof a + " with value " + a);
		}
		if (n in a) a = a[n];
		else if (r !== void 0) return r;
		else throw Error("Undefined path in data: " + t);
	}
	return a;
}
//#endregion
//#region src/stores/helpers/flattenData.ts
function mt(e, t, n) {
	let r = e.map((e) => ({
		item: e,
		id: it + st()
	}));
	t[n] = r.map((e) => e.id), r.forEach((e) => {
		if (e.item !== null && typeof e.item == "object" && !(e.item instanceof Date) && !(typeof File < "u" && e.item instanceof File)) {
			let r = "";
			Array.isArray(e.item) || (r = "/properties"), ht(e.item, t, `${n}.${e.id}${r}`);
		} else t[`${n}.${e.id}`] = e.item;
	});
}
function ht(e, t = {}, n = "/properties") {
	if (Array.isArray(e)) mt(e, t, n);
	else for (let [r, i] of Object.entries(e)) {
		let e = `${n}/${r}`;
		Array.isArray(i) ? mt(i, t, e) : typeof i == "object" && i ? ht(i, t, `${e}/properties`) : t[e] = i;
	}
	return t;
}
//#endregion
//#region src/renderings/default/DefaultComponents.ts
var gt = { ConfirmationModal: /* @__PURE__ */ l({
	__name: "ConfirmationModal",
	props: {
		title: {},
		confirmButtonText: {},
		cancelButtonText: {},
		hideCancelButton: { type: Boolean },
		confirmButtonVariant: {},
		cancelButtonVariant: {}
	},
	emits: ["confirm", "cancel"],
	setup(e, { expose: t, emit: n }) {
		let r = n, i = A();
		return t({ show: () => {
			confirm(i.default({})[0]?.children) ? r("confirm") : r("cancel");
		} }), () => {};
	}
}) };
//#endregion
//#region src/stores/formStructure.ts
function _t(e, t = "/properties/") {
	let n = {};
	for (let [r, i] of Object.entries(e.properties || {})) if (typeof i != "boolean") {
		if (i.type === "object") n = {
			...n,
			..._t(i, t + r + "/properties/")
		};
		else if (i.default !== void 0) {
			let e = i.default;
			e === "$now" && (e = (/* @__PURE__ */ new Date()).toISOString()), n[t + r] = e;
		}
	}
	return n;
}
function vt(e) {
	return ge("structure-" + e, {
		state: () => ({
			jsonSchema: void 0,
			uiSchema: void 0,
			components: void 0,
			mappers: [],
			buttonWaiting: {},
			currentWizardPage: 0,
			wizardValidateFunctions: [],
			formStateWasValidated: !1
		}),
		getters: { defaultData: (e) => {
			if (!e.jsonSchema) return {};
			let t = _t(e.jsonSchema);
			return Object.entries(t).forEach(([e, n]) => {
				Array.isArray(n) && mt(n, t, e);
			}), t;
		} },
		actions: { getComponent(e) {
			let t = this.components;
			if (!t) throw Error("Components not initialized yet");
			let n = t[e];
			if (n ||= gt[e], !n) throw Error(`Component ${e} not found`);
			return n;
		} }
	});
}
var yt = /* @__PURE__ */ new Map();
function bt(e) {
	return yt.has(e) || yt.set(e, vt(e)), yt.get(e)();
}
//#endregion
//#region src/Mappers/MapperClass.ts
var xt = class {
	clone(e) {
		return JSON.parse(JSON.stringify(e));
	}
	cloneUiElement(e) {
		return this.clone(e);
	}
	cloneJsonElement(e) {
		return this.clone(e);
	}
	cloneElements(e, t) {
		return {
			newJsonElement: this.cloneJsonElement(e),
			newUiElement: this.cloneUiElement(t)
		};
	}
}, St = class extends xt {}, Ct = class extends xt {
	jsonSchema;
	uiSchema;
	savePath;
	scope;
	jsonElement;
	uiElement;
	formId;
	registerSchemata(e, t, n, r, i, a, o = "default") {
		this.jsonSchema = e, this.uiSchema = t, this.scope = n, this.savePath = r, this.jsonElement = i, this.uiElement = a, this.formId = o;
	}
};
//#endregion
//#region src/Mappers/oneOfToEnumMapper.ts
function wt(e) {
	return typeof e == "object" && e.const !== void 0 && e.title !== void 0;
}
var Tt = class extends St {
	map(e, t) {
		if (K(e, "oneOf")) {
			let n, r = {};
			for (let t of e.oneOf) {
				if (!wt(t)) return console.warn("oneOf element is not a custom oneOf element"), null;
				n ? n.push(t.const) : n = [t.const], r[t.const] = t.title;
			}
			if ((n?.length || 0) < 1) return console.warn("No values found in oneOf element"), null;
			{
				let { newJsonElement: i, newUiElement: a } = this.cloneElements(e, t);
				return i.enum = n, delete i.oneOf, a.options = { enumTitles: r }, {
					jsonElement: i,
					uiElement: a
				};
			}
		}
		return {
			jsonElement: e,
			uiElement: t
		};
	}
}, Et = class extends Ct {
	conditionsAndResults = [];
	dependencies = [];
	registerSchemata(e, t, n, r, i, a) {
		super.registerSchemata(e, t, n, r, i, a), this.conditionsAndResults = this.getConditionsAndResults(), this.setDependencies();
	}
	setDependencies() {
		let e = /* @__PURE__ */ new Set();
		for (let t of this.conditionsAndResults) for (let n of t.conditions) e.add(n.savePath);
		this.dependencies = Array.from(e);
	}
	getDependencies() {
		return this.dependencies;
	}
	getFieldName() {
		return ut(this.scope);
	}
	parseCondition([e, t]) {
		let n, r;
		if ("const" in t) n = "const", r = t.const;
		else if ("enum" in t) n = "enum", r = t.enum;
		else if ("contains" in t) if ("const" in t.contains) n = "containsConst", r = t.contains.const;
		else if ("enum" in t.contains) n = "containsEnum", r = t.contains.enum;
		else throw Error("Invalid contains condition");
		else if ("minLength" in t) n = "minLength", r = t.minLength;
		else throw Error("Invalid condition");
		let i = this.scopeToSavePath(e);
		return {
			value: r,
			type: n,
			key: e,
			savePath: i
		};
	}
	scopeToSavePath(e) {
		let t = e, n = this.savePath?.split("/");
		for (let e = n?.length ?? 0; e >= 0; --e) {
			let r = n?.slice(0, e).join("/");
			if (!r) break;
			if (t.includes(Y(r))) {
				t = t.replace(Y(r), r);
				break;
			}
		}
		return t;
	}
	addRequiredConditions(e, t, n) {
		let r = [], i = "required" in e && e.required || [];
		for (let e of i) {
			let i = n + "/properties/" + e, a = this.scopeToSavePath(i);
			t.some((e) => e.savePath === a) || r.push({
				key: e,
				savePath: a,
				value: null,
				type: "required"
			});
		}
		return r;
	}
	parseConditions(e, t) {
		let n = [];
		if ("properties" in e) {
			let r = t + "/properties", i = e.properties;
			for (let [e, t] of Object.entries(i || {})) {
				let i = r + "/" + e;
				Zt(t) ? n.push(this.parseCondition([i, t])) : n = n.concat(this.parseConditions(t, i));
			}
		} else if ("items" in e) {
			let r = t + "/items";
			Zt(e.items) ? n.push(this.parseCondition([r, e.items])) : en(e.items) && (n = n.concat(this.parseConditions(e.items, r)));
		}
		return n = n.concat(this.addRequiredConditions(e, n, t)), n;
	}
	getConditionsAndResultsFromAllOf(e, t) {
		if (!this.jsonSchema) return [];
		let n;
		if (be.has(this.jsonSchema, e)) n = be.get(this.jsonSchema, e);
		else return [];
		if (!n || !Array.isArray(n)) return [];
		let r = n.filter(nn);
		r.length > 0 && r.length !== n.length && console.warn(`Unsupported if/then/else structure(s) found in ${e}`, n.filter((e) => !nn(e)));
		let i = t.replace(W(e, -1) + "/", "");
		return r.map((t) => {
			let n = pt(t.then, i, "/", null), r = pt(t.else, i, "/", null), a = W(i, -2), o = pt(t.then, a + "/required", "/", null), s = pt(t.else, a + "/required", "/", null);
			if (!(!n && !r && !o && !s)) return {
				conditions: this.parseConditions(t.if, W(e, -1)),
				then: n || void 0,
				else: r || void 0,
				thenRequired: o || void 0,
				elseRequired: s || void 0
			};
		}).filter((e) => e !== void 0);
	}
	getConditionsAndResults() {
		let e = [];
		if (!this.scope || !this.jsonSchema || !this.uiSchema) return e;
		for (let t = -2; this.scope.split("/").length + t >= 0; t -= 2) {
			let n = W(this.scope, t).replace(/\/properties$/, "") + "/allOf";
			n = Y(n), e = e.concat(this.getConditionsAndResultsFromAllOf(n, this.scope));
		}
		return e;
	}
	checkRequiredConditionFulfilled(e, t, n) {
		return on(e) && e !== "" ? !0 : Object.keys(t).filter((e) => e.startsWith(n + "/")).some((e) => on(t[e]) && t[e] !== "");
	}
	checkConditionFulfilled(e, t) {
		if (!this.savePath || !this.scope) return !1;
		let n = t[e.savePath];
		switch (e.type) {
			case "const": return we(n, e.value);
			case "enum": return Array.isArray(e.value) ? e.value.includes(n) : !1;
			case "containsConst": return Array.isArray(n) ? n.includes(e.value) : !1;
			case "containsEnum": return Array.isArray(n) ? n.some((t) => Array.isArray(e.value) && e.value.includes(t)) : !1;
			case "minLength": return typeof e.value == "number" ? (n?.length ?? 0) >= e.value : !1;
			case "required": return this.checkRequiredConditionFulfilled(n, t, e.savePath);
		}
	}
	async map(e, t, n) {
		let r = this.getFieldName();
		if (!this.jsonSchema || !this.uiSchema || !this.savePath || !r) return {
			jsonElement: e,
			uiElement: t
		};
		let { newJsonElement: i, newUiElement: a } = this.cloneElements(e, t), o = !1, s = !1;
		for (let e of this.conditionsAndResults) {
			let { then: t, else: c, elseRequired: l, thenRequired: u } = e;
			if (!t && !c && !u && !l) continue;
			let d = e.conditions.every((e) => this.checkConditionFulfilled(e, n)), f = d ? t || {} : c || {};
			for (let [e, t] of Object.entries(f)) if (Ht(e)) {
				if (typeof t != "object") i[e] !== t && (i[e] = t, o = !0);
				else if (t) {
					let n = Ce(i[e] || {}, t, { arrayMerge: (e, t, n) => t });
					JSON.stringify(n) !== JSON.stringify(i[e] || {}) && (i[e] = n, o = !0);
				}
			}
			(d ? u : l)?.includes(r) && (a.options ||= {}, a.options.forceRequired = !0, s = !0);
		}
		return {
			jsonElement: o ? i : e,
			uiElement: s ? a : t
		};
	}
};
//#endregion
//#region src/renderings/renderHelpers/utilities.ts
function G(e, t, n) {
	if (q(e, t)) {
		let n = e.options[t];
		if (n !== void 0) return n;
	}
	return n;
}
function Dt(e) {
	let t = {}, n = G(e, "preHtml");
	n && (t.pre = {
		type: "HTML",
		htmlData: n
	});
	let r = G(e, "postHtml");
	return r && (t.post = {
		type: "HTML",
		htmlData: r
	}), t;
}
//#endregion
//#region src/components/ShowOnLogic.ts
function Ot(e) {
	switch (e) {
		case "EQUALS": return (e, t) => e == t;
		case "NOT_EQUALS": return (e, t) => e != t;
		case "GREATER": return (e, t) => e > t;
		case "GREATER_OR_EQUAL": return (e, t) => e >= t;
		case "SMALLER": return (e, t) => e < t;
		case "SMALLER_OR_EQUAL": return (e, t) => e < t;
	}
}
var kt = RegExp(`^([^.\\s]+)\\.(${it}[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})`);
function At(e, t) {
	let { formDataStore: n } = X(t), r = {};
	if (e.type === "Control") {
		let t = e.scope.split("/");
		t.map((e, n) => {
			let r = e.match(kt);
			return r ? {
				arrayName: t.slice(0, n).join("/") + "/" + r[1],
				arrayAlias: r[2]
			} : null;
		}).forEach((e) => {
			if (e) {
				let t = Y(e.arrayName);
				r[t] = n.arrayAliasIndices.get(e.arrayAlias || "") ?? 0;
			}
		});
	}
	return r;
}
function jt(e, n) {
	let { formDataStore: r } = X(n);
	if (Vt(e.showOn)) return t(() => {
		if (!Vt(e.showOn)) throw Error("This should not happen");
		let t = Ot(e.showOn.type), n = e.showOn.referenceValue;
		try {
			return t(Te.getPropertyByString(r.cleanedFormData.json, e.showOn.path, ""), n);
		} catch (t) {
			return t instanceof ke && console.warn(`Error while evaluating showOn rule: ${t.message}`, e.showOn), !1;
		}
	});
	{
		let t = S(!1), i = new De(), a;
		try {
			a = i.parseRule(e.showOn);
		} catch (n) {
			return console.warn(`Error while parsing showOn rule '${e.showOn?.id}'`, n), t;
		}
		return r.$subscribe(() => {
			let i = {
				$selfIndices: At(e, n),
				...r.cleanedFormData.json
			};
			a.evaluate(i).then((e) => {
				t.value = e;
			}).catch((e) => {
				t.value = !1, e instanceof Ee ? console.warn(`Error while evaluating showOn rule "${a.id}": ${e.message}\nIn formula:`, e.context, "with value", e.value) : e instanceof Oe ? console.warn(`Error while evaluating showOn rule "${a.id}": ${e.message}\nIn formula:`, e.context) : console.warn(`Error while evaluating showOn rule "${a.id}": ${e.message}`);
			});
		}), t;
	}
}
function Mt(e, t, n) {
	let r = e;
	return e.type === "Control" && (r = rt(e, t)), Lt(r) ? jt(r, n) : S(!0);
}
//#endregion
//#region src/Mappers/ritaDependentOptionsMapper.ts
var Nt = class e extends Ct {
	depsRuleMap = {};
	dependencies = [];
	static parser = new De();
	getDependencies() {
		return this.dependencies;
	}
	async map(e, t, n, r) {
		if (Object.keys(this.depsRuleMap).length === 0) return {
			jsonElement: e,
			uiElement: t
		};
		let i = this.cloneJsonElement(e), a = {
			$selfIndices: At(t, this.formId),
			...r
		}, o = !1, s = [];
		for (let [e, t] of Object.entries(this.depsRuleMap)) s.push([e, await t.evaluate(a)]);
		let c = s.filter(([e, t]) => !t).map(([e, t]) => e);
		return c.length > 0 && (i.enum = i.enum?.filter((e) => !c.includes(e)), o = !0), {
			jsonElement: o ? i : e,
			uiElement: t
		};
	}
	registerSchemata(e, t, n, r, i, a, o) {
		super.registerSchemata(e, t, n, r, i, a, o);
		let s = /* @__PURE__ */ new Set();
		this.depsRuleMap = this.getOptionFilterDependencies(a, s, r), this.dependencies = Array.from(s);
	}
	getOptionFilterDependencies(t, n, r) {
		let i = {}, a = G(t, "optionFilters");
		if (a) for (let [t, r] of Object.entries(a)) try {
			let a = e.parser.parseRule(r);
			i[t] = a;
			let o = Ae([a]);
			for (let e of o.pathSet) {
				let t = "/properties/" + e.split("[")[0]?.split(".").join("/properties/");
				n.add(t);
			}
		} catch (e) {
			console.warn(`Invalid rule ${r.id} for option ${t}:`, e);
		}
		return i;
	}
}, Pt = class extends Ct {
	dependencies = [];
	getDependencies() {
		return this.dependencies;
	}
	registerSchemata(e, t, n, r, i, a) {
		super.registerSchemata(e, t, n, r, i, a);
		let o = yn(e, W(n, -2) + "/dependentRequired");
		if (!o) return;
		let s = Object.entries(o).map(([e, t]) => ({
			key: e,
			requiresThis: t.includes(n.split("/").pop() || "")
		})).filter(({ requiresThis: e }) => e).map(({ key: e }) => e);
		this.dependencies = s.map((e) => W(r, -1) + "/" + e);
	}
	async map(e, t, n) {
		let r = !1;
		for (let e of this.dependencies) if (n[e]) {
			r = !0;
			break;
		}
		if (r) {
			let n = this.cloneUiElement(t);
			return n.options ||= {}, n.options.forceRequired = !0, {
				jsonElement: e,
				uiElement: n
			};
		} else return {
			jsonElement: e,
			uiElement: t
		};
	}
};
//#endregion
//#region src/typings/typeValidators.ts
function Ft(e, t) {
	return e in t;
}
function K(e, t) {
	if (!(typeof e == "object" && e) || !(t in e)) return !1;
	let n = e;
	return n[t] !== void 0 && n[t] !== null;
}
function It(e) {
	return typeof e == "object" && !!e && !Array.isArray(e);
}
function Lt(e) {
	return K(e, "showOn");
}
function Rt(e) {
	return Array.isArray(e.elements);
}
function zt(e) {
	return e ? "displayAs" in e && e?.displayAs === "buttons" : !1;
}
function Bt(e) {
	return K(e, "options") && K(e.options, "cssClass");
}
function Vt(e) {
	return e && "path" in e && "type" in e && "referenceValue" in e;
}
function Ht(e) {
	return Se.find((t) => t === e) !== void 0;
}
function q(e, t) {
	return K(e, "options") && K(e.options, t);
}
function Ut(e) {
	return K(e, "items") && typeof e.items == "object" && !Array.isArray(e.items);
}
function Wt(e, t = !0) {
	return typeof e == "number" || typeof e == "string" || t && typeof e == "symbol";
}
function Gt(e) {
	return K(e, "items") && K(e.items, "enum") && Array.isArray(e.items.enum) && e.items.enum.every((e) => Wt(e, !1));
}
function Kt(e) {
	return [
		"text",
		"time",
		"date",
		"datetime-local",
		"email",
		"password",
		"search",
		"url",
		"tel",
		"color",
		"hidden"
	].includes(e);
}
function qt(e) {
	return Kt(e) && e !== "hidden";
}
function Jt(e) {
	return e instanceof St;
}
function Yt(e) {
	return e instanceof Ct;
}
function Xt(e) {
	return Array.isArray(e) && e.every(nn);
}
function Zt(e) {
	return It(e) ? K(e, "const") || K(e, "enum") || K(e, "minLength") || K(e, "contains") && (K(e.contains, "const") || K(e.contains, "enum")) : !1;
}
function Qt(e) {
	return It(e) ? K(e, "properties") && It(e.properties) && Object.values(e.properties).every($t) || K(e, "items") && $t(e.items) || K(e, "required") && on(e.required) : !1;
}
function $t(e) {
	return Zt(e) || Qt(e);
}
function en(e) {
	return Qt(e);
}
function tn(e) {
	return It(e);
}
function nn(e) {
	return It(e) ? K(e, "if") && en(e.if) && "then" in e && tn(e.then) && ("else" in e ? tn(e.else) : !0) : !1;
}
function rn(e) {
	return e !== void 0;
}
function an(e) {
	return e.every(rn);
}
function on(e) {
	return e != null;
}
function sn(e) {
	return e.type === "Wizard";
}
function cn(e) {
	return !sn(e);
}
function ln(e) {
	return e ? "checkValidity" in e && typeof e.checkValidity == "function" && "reportValidity" in e && typeof e.reportValidity == "function" : !1;
}
function un(e) {
	return ln(e) && "setCustomValidity" in e && typeof e.setCustomValidity == "function";
}
//#endregion
//#region src/stores/helpers/setPropertyByScope.ts
function dn(e, t, n) {
	let r = "!#index#!", i = RegExp(`${r}\\w+${r}`);
	if (n === void 0) return;
	let a = t.split("/").filter((e) => e !== "").filter((e, t) => !(t % 2 == 0 && e === "properties")).join(".").replace(/\[(\w+)]/g, `.${r}$1${r}`).split(".");
	for (let t = 0; t < a.length; t++) {
		let o = a[t];
		o && (i.test(o) && (o = parseInt(o.replace(r, ""))), t === a.length - 1 ? e[o] = e[o] || n : (i.test(a[t + 1] ?? "") ? e[o] = e[o] || [] : e[o] = e[o] || {}, e = e[o]));
	}
}
//#endregion
//#region src/stores/helpers/array.ts
function fn(e, t) {
	let n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set();
	for (let [i, a] of Object.entries(e)) wn(i, t) && (r.add(i), Array.isArray(a) && a.forEach((e, t) => {
		ct(e) && n.set(e, t);
	}));
	return {
		arrayIndices: n,
		arrays: r
	};
}
//#endregion
//#region src/stores/helpers/cleanData.ts
function pn(e) {
	let t = {};
	for (let [n, r] of Object.entries(e)) dn(t, n, r);
	return t;
}
function mn(e, t) {
	for (let [n, r] of e.entries()) t = t.replace(`.${n}`, `[${r}]`);
	return t;
}
function hn(e, t, n) {
	let r = {}, { arrayIndices: i, arrays: a } = fn(e, n);
	for (let t of a) {
		let n = e[t];
		Array.isArray(n) && !n.filter((e) => ct(e)).length && n.length > 0 && (r[mn(i, t)] = [...n]);
	}
	for (let [t, a] of Object.entries(e)) !wn(t, n) && a !== void 0 && (r[mn(i, t)] = a);
	for (let n of Object.values(t)) {
		let t = e[n.key];
		t && Array.isArray(t) && t.length === 0 && (n.jsonSchema.minItems || 0) > 0 && !n.required && delete r[mn(i, n.key)];
	}
	return {
		scopes: r,
		json: pn(r)
	};
}
//#endregion
//#region src/stores/formData.ts
function gn(e) {
	return ge("data-" + e, {
		state: () => ({
			formData: {},
			defaultFormData: {},
			arrays: {}
		}),
		getters: {
			arrayAliasIndices: (t) => fn(t.formData, e).arrayIndices,
			cleanedFormData: (t) => hn(t.formData, t.arrays, e)
		}
	});
}
var _n = /* @__PURE__ */ new Map();
function vn(e) {
	return _n.has(e) || _n.set(e, gn(e)), _n.get(e)();
}
//#endregion
//#region src/computedProperties/json.ts
function J() {
	let e = u(Ye), t = u(Qe);
	if (!rn(e) || !rn(t)) throw Error("fs and savePath must be provided");
	return {
		jsonElement: O(() => e.value.jsonElement),
		layoutElement: O(() => e.value.uiElement),
		savePath: t
	};
}
function yn(...e) {
	return be.has(...e) ? be.get(...e) : null;
}
function bn(e) {
	return t(() => W(e.value.scope, -2));
}
function xn(e) {
	let n = Cn(bn(e).value + "/required", !0);
	return t(() => {
		if (e.value.options?.forceRequired) return !0;
		let t = ut(e.value.scope);
		return !!(n.value !== void 0 && Array.isArray(n.value) && n.value.includes(t));
	});
}
function Sn(e) {
	let t = e.toLowerCase().split("_");
	return t.forEach((e, n) => {
		e && (t[n] = (e[0]?.toUpperCase() ?? "") + e.slice(1));
	}), t.join(" ");
}
function Y(e, t = "items", n = "") {
	return e.replace(RegExp(`(?<=${n})\\.${it}[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}`, "g"), "/" + t);
}
function X(e) {
	let t = e || u(Je);
	if (!t) throw Error("Form ID provider not found");
	return {
		formStructureStore: bt(t),
		formDataStore: vn(t)
	};
}
function Cn(e, n = !1) {
	return t(() => {
		let t = e, { jsonSchema: r } = B(X().formStructureStore);
		return r.value ? (t = Y(t), yn(r.value || {}, t) || (n || console.error("No json data under scope " + e), null)) : null;
	});
}
function wn(e, t) {
	let { jsonSchema: n } = B(X(t).formStructureStore), r = Y(e);
	return yn(n.value || {}, r)?.type === "array";
}
function Tn(e) {
	return e.reduce((e, t) => {
		let n = !(typeof t == "string" && ct(t));
		return e || n;
	}, !1);
}
function En(e) {
	let { jsonSchema: n } = B(X().formStructureStore), r = Cn(e.value.scope), i = xn(e), a = t(() => i.value && r.value?.type !== "object");
	return t(() => n.value ? (r.value?.title || Sn(e.value.scope.split("/").pop() || "")).concat(a.value ? "*" : "") : "");
}
//#endregion
//#region src/computedProperties/misc.ts
function Z(e) {
	return t(() => ("vjf_control_for_" + e).replace(/\//g, "_"));
}
function Dn() {
	return Math.random().toString(36).substring(7);
}
//#endregion
//#region src/renderings/bootstrap/HelpPopover.vue
var On = /* @__PURE__ */ l({
	__name: "HelpPopover",
	setup(e) {
		let { layoutElement: t } = J();
		return (e, i) => k(t)?.options?.help?.text ? (b(), n(k(pe), { key: 0 }, {
			target: N(() => [c(k(F), {
				pill: "",
				variant: k(t).options.help.variant ?? "primary"
			}, {
				default: N(() => [s(E(k(t).options.help.label ?? "i"), 1)]),
				_: 1
			}, 8, ["variant"])]),
			default: N(() => [s(" " + E(k(t).options.help.text), 1)]),
			_: 1
		})) : r("", !0);
	}
}), kn = /* @__PURE__ */ l({
	__name: "CheckboxControl",
	setup(e) {
		let { formDataStore: t } = X(), { formData: r } = B(t), { layoutElement: i, savePath: a } = J(), o = Z(a), l = En(i);
		return (e, t) => (b(), n(k(z), {
			id: k(o),
			modelValue: k(r)[k(a)],
			"onUpdate:modelValue": t[0] ||= (e) => k(r)[k(a)] = e,
			class: "vjf_checkbox"
		}, {
			default: N(() => [s(E(k(l)) + " ", 1), c(On)]),
			_: 1
		}, 8, ["id", "modelValue"]));
	}
}), An = /* @__PURE__ */ l({
	__name: "ErrorViewer",
	props: { header: {} },
	setup(e) {
		let t = e;
		return (e, r) => (b(), n(k(R), {
			class: "vjw_errorViewer",
			"header-bg-variant": "danger",
			"header-text-variant": "white",
			header: t.header,
			"header-border-variant": "danger",
			"border-variant": "danger"
		}, {
			default: N(() => [w(e.$slots, "default")]),
			_: 3
		}, 8, ["header"]));
	}
}), jn = { class: "text-muted" }, Mn = /* @__PURE__ */ l({
	__name: "DefaultControl",
	setup(e) {
		let { jsonElement: t } = J();
		return (e, r) => (b(), n(An, { header: "Unsupported" }, {
			default: N(() => [r[0] ||= a("p", null, "This field type is not supported!", -1), a("p", jn, E(k(t)), 1)]),
			_: 1
		}));
	}
}), Nn = /* @__PURE__ */ l({
	__name: "VJFButton",
	props: { layoutElement: {} },
	setup(e) {
		let r = e, i = st(), { formStructureStore: a } = X(), { buttonWaiting: o } = B(a);
		o.value[i] = !1;
		let s = a.getComponent("Button"), c = t(() => {
			let e = JSON.stringify({
				...r.layoutElement.options?.submitOptions,
				id: i
			});
			return encodeURIComponent(e);
		});
		return (t, r) => (b(), n(T(k(s)), {
			"layout-element": e.layoutElement,
			"submit-options": c.value,
			formnovalidate: e.layoutElement.options?.formnovalidate ? "formnovalidate" : void 0,
			waiting: k(o)[k(i)]
		}, null, 8, [
			"layout-element",
			"submit-options",
			"formnovalidate",
			"waiting"
		]));
	}
}), Pn = /* @__PURE__ */ l({
	__name: "ButtonGroup",
	props: { layoutElement: {} },
	setup(t) {
		return (r, a) => (b(), n(k(L), {
			class: "w-100",
			vertical: t.layoutElement.options?.vertical
		}, {
			default: N(() => [(b(!0), i(e, null, C(t.layoutElement.buttons, (e) => (b(), n(Nn, {
				key: e.text,
				"layout-element": e
			}, null, 8, ["layout-element"]))), 128))]),
			_: 1
		}, 8, ["vertical"]));
	}
});
//#endregion
//#region src/formControlInputValidation/NumberValidation.ts
function Fn(e, t) {
	let n = new je(e), r = new je(t);
	return n.modulo(r).eq(0);
}
function In(e, t, n, r, i) {
	return t === void 0 ? i ? (r?.setCustomValidity(n?.getString("errors.number.invalidNumber") || "error"), !1) : (r?.setCustomValidity(""), !0) : Number.isNaN(Number(t)) ? (r?.setCustomValidity(n?.getString("errors.number.invalidNumber") || "error"), !1) : e.multipleOf ? Fn(t, e.multipleOf) ? (r?.setCustomValidity(""), !0) : (r?.setCustomValidity(n?.getStringTemplate("errors.number.multipleOf", e.multipleOf) || "error"), !1) : (r?.setCustomValidity(""), !0);
}
//#endregion
//#region src/renderings/renderHelpers/NumberControl.ts
var Ln = /* @__PURE__ */ V({
	getComputedValidationState: () => Bn,
	getStep: () => Rn,
	setupValueAndValidation: () => zn
});
function Rn(e) {
	return t(() => e.value.type === "integer" ? e.value.multipleOf || 1 : e.value.multipleOf || "any");
}
function zn(e, t, n) {
	let { savePath: r } = J(), { formDataStore: i } = X(), { formData: a } = B(i), o = S(void 0);
	return M(o, (e) => {
		e === "" || e === void 0 ? a.value[r] = void 0 : a.value[r] = Number(e);
	}), M(() => a.value[r], (e) => {
		o.value !== e?.toString() && (o.value = e?.toString());
	}, { immediate: !0 }), {
		state: Bn(e, t, n, o),
		value: o
	};
}
function Bn(e, n, r, i) {
	let { formStructureStore: a } = X(), { formStateWasValidated: o } = B(a), s = u(U), c = S(!0);
	return M(i, () => {
		c.value = In(e.value, i.value, s, document.getElementById(n), r);
	}, { immediate: !0 }), t(() => {
		if (o.value) return c.value;
	});
}
//#endregion
//#region src/renderings/bootstrap/controls/NumberControl.vue
var Vn = /* @__PURE__ */ l({
	__name: "NumberControl",
	props: { required: { type: Boolean } },
	setup(e) {
		let { jsonElement: t, layoutElement: r, savePath: i } = J(), a = Z(i), o = e, s = Rn(t), { state: c, value: l } = zn(t, a.value, o.required);
		return (i, o) => (b(), n(k(ae), {
			id: k(a),
			modelValue: k(l),
			"onUpdate:modelValue": o[0] ||= (e) => d(l) ? l.value = e : null,
			class: "vjf_input",
			step: k(s),
			min: k(t).minimum,
			max: k(t).maximum,
			type: k(G)(k(r), "range", !1) ? "range" : "number",
			required: e.required,
			state: k(c),
			autocomplete: k(G)(k(r), "autocomplete", "on")
		}, null, 8, [
			"id",
			"modelValue",
			"step",
			"min",
			"max",
			"type",
			"required",
			"state",
			"autocomplete"
		]));
	}
});
//#endregion
//#region src/computedProperties/css.ts
function Q(e, ...n) {
	return t(() => {
		let t = " " + n.join(" "), r = e;
		return d(r) && (r = r.value), G(r, "cssClass", "") + t;
	});
}
//#endregion
//#region src/components/LayoutElements/htmlRenderer.vue?vue&type=script&setup=true&lang.ts
var Hn = ["innerHTML"], Un = /* @__PURE__ */ l({
	__name: "htmlRenderer",
	props: { layoutElement: {} },
	setup(e) {
		let n = e, r = t(() => Me(n.layoutElement.htmlData, {
			allowedTags: Me.defaults.allowedTags.concat("img", "a", "svg"),
			allowedAttributes: {
				...Me.defaults.allowedAttributes,
				"*": [
					"style",
					"class",
					"aria-*"
				]
			}
		}));
		return (e, t) => (b(), i("span", {
			class: "vjf_htmlRenderer",
			innerHTML: r.value
		}, null, 8, Hn));
	}
}), Wn = {}, Gn = {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16"
};
function Kn(e, t) {
	return b(), i("svg", Gn, [...t[0] ||= [a("path", {
		fill: "currentColor",
		d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8L4.646 5.354a.5.5 0 0 1 0-.708"
	}, null, -1)]]);
}
var qn = /*#__PURE__*/ H(Wn, [["render", Kn], ["__scopeId", "data-v-8898cb0d"]]), Jn = {}, Yn = {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16"
};
function Xn(e, t) {
	return b(), i("svg", Yn, [...t[0] ||= [a("path", {
		fill: "currentColor",
		d: "M7 2a1 1 0 1 1-2 0a1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0a1 1 0 0 1 2 0M7 5a1 1 0 1 1-2 0a1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0a1 1 0 0 1 2 0M7 8a1 1 0 1 1-2 0a1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0a1 1 0 0 1 2 0m-3 3a1 1 0 1 1-2 0a1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0a1 1 0 0 1 2 0m-3 3a1 1 0 1 1-2 0a1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0a1 1 0 0 1 2 0"
	}, null, -1)]]);
}
var Zn = /*#__PURE__*/ H(Jn, [["render", Xn], ["__scopeId", "data-v-451bf0ec"]]), Qn = ["id"], $n = { class: "handle" }, er = /*#__PURE__*/ H(/* @__PURE__ */ l({
	__name: "ArrayItem",
	props: {
		scope: {},
		index: {},
		itemID: {},
		baseSavePath: {},
		allowRemove: { type: Boolean },
		uiSchema: {}
	},
	emits: ["delete"],
	setup(e, { emit: n }) {
		let r = e, o = lt(r.baseSavePath, r.itemID);
		x(Ze, o);
		let s = t(() => {
			let e = r.uiSchema || {
				type: "Control",
				scope: "",
				options: { label: !1 }
			};
			return e.scope = r.scope + "." + r.itemID, e;
		}), l = n, u = X().formStructureStore.getComponent("ArrayButton");
		return (t, n) => (b(), i("div", {
			id: e.itemID,
			class: "vjf_arrayItem"
		}, [c(mr, {
			"layout-element": s.value,
			"in-array-item": ""
		}, {
			prepend: N(() => [a("div", $n, [c(Zn)])]),
			append: N(() => [c(k(u), {
				variant: "outline-danger",
				disabled: !e.allowRemove,
				"aria-label": "Delete Item",
				onClick: n[0] ||= (t) => l("delete", e.itemID, k(o))
			}, {
				default: N(() => [c(qn)]),
				_: 1
			}, 8, ["disabled"])]),
			_: 1
		}, 8, ["layout-element"])], 8, Qn));
	}
}), [["__scopeId", "data-v-3f5df992"]]), tr = {}, nr = {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16"
};
function rr(e, t) {
	return b(), i("svg", nr, [...t[0] ||= [a("path", {
		fill: "currentColor",
		d: "M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"
	}, null, -1)]]);
}
var ir = /*#__PURE__*/ H(tr, [["render", rr], ["__scopeId", "data-v-9a59b4f7"]]), ar = { class: "vjf_label_wrapper" }, or = ["for"], sr = { class: "large-label" }, cr = { class: "vjf_array-help-icon-wrapper" }, lr = { key: 0 }, ur = ["id"], dr = { key: 0 }, fr = /* @__PURE__ */ l({
	__name: "ArrayControl",
	setup(o) {
		let { formStructureStore: l, formDataStore: d } = X(), f = l.getComponent("ErrorViewer"), h = l.getComponent("HelpPopover"), g = l.getComponent("ArrayButton"), v = l.getComponent("ConfirmationModal"), ee = te("delete-remaining-items-modal"), { formData: y, arrays: x } = B(d), { jsonSchema: w } = B(l), { jsonElement: T, layoutElement: D, savePath: O } = J(), A = u(U), F = Z(O), I = xn(D);
		function L(e = !1, t) {
			let n = it + st();
			if (!w.value) throw Error("jsonSchema is unexpectedly undefined");
			if (!rn(O)) throw Error("savePath must be provided");
			y.value[O].push(n), y.value[`${O}.${n}`] = t ?? "", e || m().then(() => {
				let e = document.getElementById(F.value)?.querySelectorAll(".list-group > *");
				e && (e[e.length - 1]?.querySelector("input"))?.focus();
			});
		}
		function R(e = 0) {
			let t = (T.value.minItems || 0) + e;
			for (let e = y.value[O].length; e < t; e++) L(!0);
		}
		function z() {
			R(-1), L();
		}
		let ne = En(D), re = S(!1), ie = S({
			animation: 200,
			group: `array-${ne.value}`,
			disabled: !1,
			ghostClass: "ghost"
		});
		function ae() {
			for (let e of y.value[O]) {
				let t = lt(O, e), n = Object.keys(y.value).filter((e) => e.startsWith(t));
				for (let e of n) delete y.value[e];
			}
			y.value[O] = [];
		}
		function oe(e, t) {
			if (y.value[O].length <= (T.value.minItems || 0) && y.value[O].length > 1) {
				if (I.value) return;
				ee.value?.show();
				return;
			}
			let n = y.value[O].indexOf(e);
			n > -1 ? y.value[O].splice(n, 1) : console.warn("Could not find item with id", e, "in", y.value[O]), delete y.value[t];
		}
		function se() {
			x.value[O] = {
				key: O,
				jsonSchema: T.value,
				required: I.value
			};
		}
		function ce() {
			if (!y.value[O]) y.value[O] = [];
			else if (Tn(y.value[O])) {
				let e = y.value[O];
				y.value[O] = [];
				for (let t of e) L(!0, t);
			}
			se(), I.value && R(), D.value.options?.maxFileSize && nt(D.value.scope + "/items", { options: { maxFileSize: D.value.options.maxFileSize } });
		}
		M(() => y.value[O], () => {
			y.value[O] || ce();
		}), M([() => I.value, () => T.value.minItems], () => {
			I.value && R();
		}), M([() => I.value, () => T.value], se);
		let le = t(() => y.value[O].length < (T.value.maxItems || Number.MAX_VALUE)), ue = t(() => !I.value || y.value[O].length > (T.value.minItems || 0)), de = t(() => ct(D.value.scope.split(".").pop() || ""));
		return _(ce), (t, o) => (b(), i("div", null, [
			a("div", ar, [de.value ? r("", !0) : P((b(), i("label", {
				key: 0,
				for: k(F)
			}, [a("span", sr, E(k(ne)), 1)], 8, or)), [[j, k(G)(k(D), "label", !0)]]), a("div", cr, [c(k(h))])]),
			k(T).description ? (b(), i("p", lr, E(k(T).description), 1)) : r("", !0),
			typeof k(T).items == "object" && "type" in k(T).items ? (b(), i("div", {
				key: 1,
				id: k(F),
				class: "vjf_array"
			}, [c(k(Pe), p({
				key: "draggable",
				modelValue: k(y)[k(O)],
				"onUpdate:modelValue": o[0] ||= (e) => k(y)[k(O)] = e,
				class: "list-group",
				handle: ".handle"
			}, ie.value, {
				onStart: o[1] ||= (e) => re.value = !0,
				onEnd: o[2] ||= (e) => re.value = !1
			}), {
				default: N(() => [(b(!0), i(e, null, C(k(y)[k(O)], (e, t) => (b(), i("div", {
					key: e,
					class: "draggable-array-item"
				}, [c(er, {
					scope: k(D).scope,
					"base-save-path": k(O),
					index: t,
					"item-i-d": e,
					"allow-remove": ue.value,
					onDelete: oe
				}, null, 8, [
					"scope",
					"base-save-path",
					"index",
					"item-i-d",
					"allow-remove"
				])]))), 128))]),
				_: 1
			}, 16, ["modelValue"]), c(k(g), {
				variant: "outline-primary",
				class: "w-100",
				disabled: !le.value,
				"aria-label": "Add Item",
				onClick: z
			}, {
				default: N(() => [k(G)(k(D), "addButtonText") ? (b(), i("span", dr, E(k(G)(k(D), "addButtonText")), 1)) : (b(), n(ir, { key: 1 }))]),
				_: 1
			}, 8, ["disabled"])], 8, ur)) : (b(), n(k(f), {
				key: 2,
				id: k(F),
				header: "Error"
			}, {
				default: N(() => [...o[3] ||= [s(" The type of the array's items is missing in the schema ", -1)]]),
				_: 1
			}, 8, ["id"])),
			c(k(v), {
				ref: "delete-remaining-items-modal",
				title: k(A)?.getString("modals.delete-remaining-items.title") || "",
				"confirm-button-text": k(A)?.getString("modals.delete-remaining-items.confirm"),
				"confirm-button-variant": "danger",
				"cancel-button-text": k(A)?.getString("modals.delete-remaining-items.cancel"),
				onConfirm: ae
			}, {
				default: N(() => [s(E(k(A)?.getStringTemplate("modals.delete-remaining-items.text", k(T).minItems)), 1)]),
				_: 1
			}, 8, [
				"title",
				"confirm-button-text",
				"cancel-button-text"
			])
		]));
	}
}), pr = { key: 1 }, mr = /* @__PURE__ */ l({
	__name: "Control",
	props: {
		layoutElement: {},
		inArrayItem: { type: Boolean }
	},
	setup(e) {
		let { formStructureStore: a, formDataStore: l } = X(), { jsonSchema: d, mappers: f, uiSchema: p } = B(a), m = a.getComponent("FormFieldWrapper"), _ = a.getComponent("ErrorViewer"), y = e, C = Cn(y.layoutElement.scope), { formData: D, defaultFormData: O, cleanedFormData: A } = B(l), te = S(!1);
		tt(y.layoutElement.options?.descendantControlOverrides);
		let j = u($e), P = u(Ze, void 0) || y.layoutElement.scope, F = S([]), I = S({
			jsonElement: C.value || {},
			uiElement: y.layoutElement
		});
		async function L() {
			let e = C.value || {}, t = y.layoutElement;
			t = rt(t, j);
			for (let n of F.value) {
				let r;
				Jt(n) ? r = n.map(e || {}, t) : Yt(n) && (r = await n.map(e || {}, t, D.value, A.value.json)), r ? (e = r.jsonElement, t = r.uiElement) : console.warn("Mapper failed", n);
			}
			I.value = {
				jsonElement: e || {},
				uiElement: t
			};
		}
		M([() => C.value, () => y.layoutElement], L, { immediate: !0 });
		let R = u(Je);
		if (!R) throw Error("formId is not provided");
		ee(() => {
			if (!C.value || !y.layoutElement || !d.value || !p.value) return;
			let e = /* @__PURE__ */ new Set();
			F.value = f.value.map((e) => new e());
			for (let t of F.value) if (Yt(t)) {
				t.registerSchemata(d.value, p.value, Y(y.layoutElement.scope), P, C.value, rt(y.layoutElement, j), R);
				for (let n of t.getDependencies()) e.has(n) || (e.add(n), Ne(() => D.value[n], () => {
					L();
				}, {
					debounce: 50,
					deep: !1
				}));
			}
			L();
		});
		let z = t(() => Dt(I.value.uiElement)), ne = t(() => I.value.uiElement), re = xn(ne), ie = I.value.uiElement.options?.hidden ? "hiddenControl" : "", ae = t(() => {
			if (y.layoutElement.options && "textAlign" in y.layoutElement.options && y.layoutElement.options.textAlign) return `text-align: ${y.layoutElement.options.textAlign}`;
		}), oe = Q(I.value.uiElement, "vjf_control mb-3", ie);
		x(Ye, I), x(Qe, P), x(Ze, void 0), x(et, y.inArrayItem ?? !1);
		let se = Z(P), ce = En(ne), le = t(() => {
			if (I.value.jsonElement?.enum !== void 0 && I.value.jsonElement.type !== "array") return G(I.value.uiElement, "displayAs") === "radiobuttons" || G(I.value.uiElement, "displayAs") === "buttons" ? a.getComponent("RadiobuttonControl") : a.getComponent("SelectControl");
			if (typeof I.value.jsonElement?.items == "object" && "enum" in I.value.jsonElement.items && I.value.jsonElement.type === "array") return a.getComponent("CheckboxGroupControl");
			if (I.value.jsonElement?.type === "array" && q(I.value.uiElement, "tags") && I.value.uiElement.options?.tags?.enabled) return a.getComponent("TagsControl");
			if (I.value.jsonElement?.type === "string" && I.value.jsonElement.format === "uri" || I.value.jsonElement?.type === "array" && Ut(I.value.jsonElement) && I.value.jsonElement.items.type === "string" && I.value.jsonElement.items.format === "uri" && I.value.uiElement.options?.displayAsSingleUploadField) return a.getComponent("FileControl");
			switch (I.value.jsonElement?.type) {
				case "boolean": return a.getComponent("CheckboxControl");
				case "number":
				case "integer": return a.getComponent("NumberControl");
				case "object": return a.getComponent("ObjectControl");
				case "string": return a.getComponent("StringControl");
				case "array": return fr;
				default: return a.getComponent("DefaultControl");
			}
		});
		return M(C, () => {
			C.value === void 0 && (te.value = y.layoutElement.scope);
		}), ee(() => {
			O.value[P] !== void 0 && (D.value[P] = O.value[P]);
		}), v(() => {
			D.value[P] = void 0;
		}), (t, a) => te.value ? (b(), i("div", pr, [c(k(_), { header: "Error" }, {
			default: N(() => [s(" Invalid Json Pointer: " + E(te.value), 1)]),
			_: 1
		})])) : (b(), i("div", {
			key: 0,
			class: h(k(oe))
		}, [
			z.value.pre ? (b(), n(Un, {
				key: 0,
				"layout-element": z.value.pre
			}, null, 8, ["layout-element"])) : r("", !0),
			(b(), n(T(k(m)), {
				label: k(ce),
				"label-for": k(se)
			}, o({
				default: N(() => [(b(), n(T(le.value), {
					name: I.value.uiElement.scope,
					disabled: k(G)(I.value.uiElement, "disabled"),
					placeholder: k(G)(I.value.uiElement, "placeholder"),
					required: k(re) || e.inArrayItem,
					style: g(ae.value),
					"aria-label": e.inArrayItem ? "List item" : void 0
				}, null, 8, [
					"name",
					"disabled",
					"placeholder",
					"required",
					"style",
					"aria-label"
				]))]),
				_: 2
			}, [t.$slots.prepend ? {
				name: "prepend",
				fn: N(() => [w(t.$slots, "prepend")]),
				key: "0"
			} : void 0, t.$slots.append ? {
				name: "append",
				fn: N(() => [w(t.$slots, "append")]),
				key: "1"
			} : void 0]), 1032, ["label", "label-for"])),
			z.value.post ? (b(), n(Un, {
				key: 1,
				"layout-element": z.value.post
			}, null, 8, ["layout-element"])) : r("", !0)
		], 2));
	}
}), hr = {};
function gr(e, t) {
	return b(), i("hr");
}
var _r = /*#__PURE__*/ H(hr, [["render", gr]]), vr = /* @__PURE__ */ l({
	__name: "VerticalLayout",
	props: { layoutElement: {} },
	setup(r) {
		let a = r, o = Q(a.layoutElement, "vjf_verticalLayout"), s = t(() => Rt(a.layoutElement) ? dt(a.layoutElement.elements) : []);
		return (t, r) => (b(), i("div", { class: h(k(o)) }, [(b(!0), i(e, null, C(s.value, (e) => (b(), n(Tr, {
			key: e.uuid,
			"layout-element": e
		}, null, 8, ["layout-element"]))), 128))], 2));
	}
}), yr = { key: 0 }, br = {
	Control: mr,
	Divider: _r,
	Group: /* @__PURE__ */ H(/* @__PURE__ */ l({
		__name: "Group",
		props: { layoutElement: {} },
		setup(e) {
			let t = Q(e.layoutElement, "vjf_group");
			return (n, o) => (b(), i("fieldset", { class: h(k(t)) }, [
				P(a("legend", null, E(e.layoutElement.options?.label || "Unnamed group"), 513), [[j, e.layoutElement.options?.label]]),
				e.layoutElement.options?.description ? (b(), i("p", yr, E(e.layoutElement.options.description), 1)) : r("", !0),
				c(vr, {
					class: "vjf_fieldset-content vjf_indented",
					"layout-element": {
						...e.layoutElement,
						type: "VerticalLayout"
					}
				}, null, 8, ["layout-element"])
			], 2));
		}
	}), [["__scopeId", "data-v-fcf61396"]]),
	HorizontalLayout: /* @__PURE__ */ l({
		__name: "HorizontalLayout",
		props: { layoutElement: {} },
		setup(r) {
			let a = r, o = Q(a.layoutElement, "vjf_horizontalLayout"), s = t(() => Rt(a.layoutElement) ? dt(a.layoutElement.elements) : []);
			return (t, r) => (b(), i("div", { class: h(k(o)) }, [(b(!0), i(e, null, C(s.value, (e) => (b(), n(Tr, {
				key: e.uuid,
				"layout-element": e
			}, null, 8, ["layout-element"]))), 128))], 2));
		}
	}),
	VerticalLayout: vr,
	htmlRenderer: Un
}, xr = {};
function Sr(e, t) {
	return "Unknown Component";
}
var Cr = /*#__PURE__*/ H(xr, [["render", Sr]]), wr = {
	vjfButtonGroup: /* @__PURE__ */ l({
		__name: "ButtonGroup",
		props: { layoutElement: {} },
		setup(e) {
			let t = X().formStructureStore.getComponent("Buttongroup");
			return (r, i) => (b(), n(T(k(t)), { "layout-element": e.layoutElement }, null, 8, ["layout-element"]));
		}
	}),
	vjfButton: Nn
}, Tr = /* @__PURE__ */ l({
	__name: "FormWrap",
	props: { layoutElement: {} },
	setup(e) {
		let { formStructureStore: t } = X(), i = t.getComponent("showOnWrapper"), a = u(Je);
		if (!a) throw Error("`formIdProviderKey` is not provided.");
		let o = e;
		function s(e) {
			switch (e) {
				case "Control": return br.Control;
				case "VerticalLayout": return br.VerticalLayout;
				case "HorizontalLayout": return br.HorizontalLayout;
				case "Group": return br.Group;
				case "HTML": return br.htmlRenderer;
				case "Divider": return br.Divider;
				case "Button": return wr.vjfButton;
				case "Buttongroup": return wr.vjfButtonGroup;
				case "Modal": return t.getComponent("Modal");
				default: return Cr;
			}
		}
		let c = f(s(o.layoutElement.type)), l = o.layoutElement, d = u($e);
		l.type === "Control" && rt(l, d);
		let p = Mt(l, d, a);
		return (t, a) => (b(), n(k(i), { visible: k(p) }, {
			default: N(() => [k(p) ? (b(), n(T(k(c)), {
				key: 0,
				"layout-element": e.layoutElement
			}, null, 8, ["layout-element"])) : r("", !0)]),
			_: 1
		}, 8, ["visible"]));
	}
}), Er = ["id"], Dr = { key: 0 }, Or = { class: "vjf_object_help" }, kr = { key: 1 }, Ar = { class: "vjf_indented" }, jr = /*#__PURE__*/ H(/* @__PURE__ */ l({
	__name: "ObjectControl",
	setup(o) {
		let { jsonElement: l, layoutElement: u, savePath: d } = J(), f = Z(d), p = Q(u, "vjf_object"), m = En(u), g = t(() => ft(l.value, { scopeBase: u.value.scope }).layout.elements.filter((e) => e.type === "Control"));
		return (t, o) => (b(), i("fieldset", {
			id: k(f),
			class: h(k(p))
		}, [
			k(u).options?.label !== !1 && k(m) ? (b(), i("legend", Dr, [s(E(k(m)) + " ", 1), a("span", Or, [c(On)])])) : r("", !0),
			k(l).description ? (b(), i("p", kr, E(k(l).description), 1)) : r("", !0),
			a("div", Ar, [(b(!0), i(e, null, C(g.value, (e) => (b(), n(Tr, {
				key: e.scope,
				"layout-element": e
			}, null, 8, ["layout-element"]))), 128))])
		], 10, Er));
	}
}), [["__scopeId", "data-v-bbf0e2ae"]]), Mr = /* @__PURE__ */ l({
	__name: "TagsControl",
	setup(e) {
		let { formDataStore: t } = X(), { formData: r } = B(t), { layoutElement: i, savePath: a } = J(), o = Z(a);
		return (e, t) => (b(), n(k(ce), {
			id: k(o),
			modelValue: k(r)[k(a)],
			"onUpdate:modelValue": t[0] ||= (e) => k(r)[k(a)] = e,
			variant: "",
			separator: " ",
			class: "vjf_tags",
			"tag-pills": k(q)(k(i), "tags") && k(i).options?.tags?.pills,
			"tag-variant": k(q)(k(i), "tags") ? k(i).options?.tags?.variant : void 0
		}, null, 8, [
			"id",
			"modelValue",
			"tag-pills",
			"tag-variant"
		]));
	}
});
//#endregion
//#region src/renderings/renderHelpers/B64File.ts
function Nr(e) {
	let t = atob(e), n = t.length, r = new Uint8Array(n);
	for (let e = 0; e < n; e++) r[e] = t.charCodeAt(e);
	return r;
}
var $ = class e {
	data;
	b64;
	constructor(e) {
		this.b64 = e, this.data = this.destructure();
	}
	destructure() {
		let e = this.b64.indexOf(",");
		if (e === -1) throw Error("Invalid base64 string");
		let t = this.b64.slice(0, e), n = this.b64.slice(e + 1), r = t.split(";");
		if (!r[0].startsWith("data:") || r[r.length - 1] !== "base64") throw Error("Invalid base64 string");
		let i = r[0].slice(5);
		if (!i) throw Error("Invalid base64 string");
		let a = r.find((e) => e.startsWith("name="));
		if (!a) return {
			mimeType: i,
			b64data: n
		};
		let o = a.slice(5), s = o.lastIndexOf(".");
		return {
			mimeType: i,
			filename: decodeURIComponent(s === -1 ? o : o.slice(0, s)),
			extension: s === -1 ? void 0 : o.slice(s + 1),
			b64data: n
		};
	}
	getBuffer() {
		return Nr(this.data.b64data);
	}
	getBlob() {
		return new Blob([this.getBuffer()], { type: this.data.mimeType });
	}
	static calculateFileNameWithExtension(e, t) {
		return e !== void 0 && t !== void 0 ? `${e}.${t}` : e === void 0 ? t === void 0 ? "" : `.${t}` : e;
	}
	getFile() {
		return new File([this.getBlob()], this.getFileNameExtension(), { type: this.data.mimeType });
	}
	getMimeType() {
		return this.data.mimeType;
	}
	getFileNameExtension() {
		let { filename: t, extension: n } = this.data;
		return e.calculateFileNameWithExtension(t, n);
	}
	getFileName() {
		let { filename: e } = this.data;
		return e ?? "";
	}
	getExtension() {
		let { extension: e } = this.data;
		return e ?? "";
	}
	getBase64Data() {
		return this.data.b64data;
	}
	getBase64Uri() {
		return this.b64;
	}
	equals(t, n = !0) {
		return e.equals(this, t, n);
	}
	static fromFile(t) {
		return new Promise((n, r) => {
			let i = new FileReader();
			i.onload = () => {
				let r = i.result.split(",")[1], a = t.name.lastIndexOf("."), o = a === -1 ? t.name : t.name.slice(0, a), s = a === -1 ? "" : t.name.slice(a + 1), c = e.calculateFileNameWithExtension(o, s), l = "";
				c && (l = `;name=${encodeURIComponent(o)}.${s}`), n(new e(`data:${t.type}${l};base64,${r}`));
			}, i.onerror = r, i.readAsDataURL(t);
		});
	}
	static equals(e, t, n = !0) {
		return n ? e.getMimeType() === t.getMimeType() && e.getFileNameExtension() === t.getFileNameExtension() && e.getBase64Data() === t.getBase64Data() : e.getBase64Data() === t.getBase64Data();
	}
};
//#endregion
//#region src/formControlInputValidation/UploadValidation.ts
function Pr(e, t, n, r, i, a, o, s) {
	if (!s) return !0;
	if (r.value && Array.isArray(e)) {
		if (a.value && (e?.length || 0) > a.value) return a.value === 1 ? s.setCustomValidity(o?.getStringTemplate("errors.fileUpload.onlyOne") || "") : s.setCustomValidity(o?.getStringTemplate("errors.fileUpload.tooManyFiles", a.value) || ""), !1;
		if (i.value && (e?.length || 0) < i.value && (t || e?.length > 0)) return i.value === 1 ? s.setCustomValidity(o?.getStringTemplate("errors.fileUpload.atLeastOne") || "") : s.setCustomValidity(o?.getStringTemplate("errors.fileUpload.tooFewFiles", i.value) || ""), !1;
	} else if (t && !e) return s.setCustomValidity(""), !1;
	if (n) {
		let t = [];
		e != null && (t = Array.isArray(e) ? e : [e]);
		let r = t.filter((e) => e.size > n);
		if (r.length > 0) return s.setCustomValidity(o?.getStringTemplate("errors.fileUpload.fileTooLarge", (n / 1024 / 1024).toFixed(2), r.map((e) => e.name).join(", ")) || ""), !1;
	}
	return s.setCustomValidity(""), !0;
}
//#endregion
//#region src/formControlInputValidation/CheckboxGroupValidation.ts
function Fr(e) {
	let t = `input[type='checkbox'][name='${e}']`;
	document.querySelectorAll(t).forEach((e) => {
		un(e) && e.setCustomValidity("");
	});
}
function Ir(e, t, n = !1) {
	let r = `input[type='checkbox'][name='${t}']`;
	n ? r += ":checked" : r += ":not(:checked)";
	let i = document.querySelector(r);
	un(i) && i.setCustomValidity(e);
}
function Lr(e, t, n, r, i) {
	if (Fr(r), t === void 0) return !e;
	if (!Gt(n)) throw Error("CheckboxGroupControl requires enum values for items");
	let a = n.minItems ?? 0, o = n.maxItems ?? n.items.enum.length;
	if (t.length < a) {
		let e;
		return e = a === 1 ? i?.getString("errors.checkboxGroup.selectAtLeastOne") : i?.getStringTemplate("errors.checkboxGroup.selectAtLeast", a), Ir(e || "", r, !1), !1;
	}
	if (t.length > o) {
		let e;
		return e = o === 1 ? i?.getString("errors.checkboxGroup.selectAtMostOne") : i?.getStringTemplate("errors.checkboxGroup.selectAtMost", o), Ir(e || "", r, !0), !1;
	}
	return !0;
}
//#endregion
//#region src/renderings/renderHelpers/FileControl.ts
var Rr = /* @__PURE__ */ V({
	getAcceptedFileTypes: () => Hr,
	getEnrichedLayoutElement: () => Ur,
	getMaxNumberOfFiles: () => Vr,
	getMinNumberOfFiles: () => Br,
	getMultiple: () => zr,
	setupFileAndValidation: () => Wr
});
function zr(e) {
	return t(() => e.value.type === "array");
}
function Br(e, n) {
	return t(() => Math.max(e.value.minItems ?? 0, +!!n));
}
function Vr(e) {
	return t(() => e.value.maxItems ?? 2 ** 53 - 1);
}
function Hr(e) {
	return t(() => {
		let t = G(e.value, "acceptedFileType", "*");
		if (!(t === "*" || Array.isArray(t) && t.includes("*"))) return t;
	});
}
function Ur(e, n) {
	return t(() => ({
		...e.value,
		options: {
			...e.value.options,
			...G(e.value, "descendantControlOverrides")?.[n + "/items"]?.options || {}
		}
	}));
}
function Wr(e) {
	let { formDataStore: n, formStructureStore: r } = X(), { formData: i } = B(n), { formStateWasValidated: a } = B(r), { jsonElement: o, layoutElement: s, savePath: c } = J(), l = u(U), d = Ur(s, c), f = zr(o), p = Br(o, e), m = Vr(o), h = S(!0), g = t(() => {
		if (a.value) return h.value;
	}), _ = S(), v = () => {
		h.value = Pr(_.value, e, d.value.options?.maxFileSize, f, p, m, l, document.querySelector(`input[name='${c}']`));
	};
	return M([
		_,
		() => o.value,
		() => d.value,
		() => f.value,
		() => p.value,
		() => m.value,
		() => e
	], v, { deep: !0 }), M(_, async (e) => {
		if (e) if (Array.isArray(e)) {
			let t = await Promise.all(e.map((e) => $.fromFile(e)));
			i.value[c] = t.map((e) => e.getBase64Uri());
		} else {
			let t = await $.fromFile(e);
			i.value[c] = t.getBase64Uri();
		}
		else f.value ? i.value[c] = [] : i.value[c] = void 0;
	}), M(() => i.value[c], async () => {
		if (f.value) {
			if (i.value[c] && Array.isArray(i.value[c])) {
				let e = i.value[c].map((e) => new $(e));
				Array.isArray(_.value) || (_.value = e.map((e) => e.getFile()));
				let t = await Promise.all(_.value.map((e) => $.fromFile(e)));
				e.find((e, n) => !e.equals(t[n])) && (_.value = e.map((e) => e.getFile()));
			}
		} else if (i.value[c]) {
			let e = new $(i.value[c]);
			_.value instanceof File || (_.value = e.getFile());
			let t = await $.fromFile(_.value);
			e.equals(t) || (_.value = e.getFile());
		}
		v();
	}, { immediate: !0 }), ee(v), {
		file: _,
		state: g
	};
}
//#endregion
//#region src/renderings/renderHelpers/FormfieldWrapper.ts
var Gr = /* @__PURE__ */ V({
	getHasPrependOrAppend: () => Kr,
	getIsObjectOrArrayViewComputed: () => Jr
});
function Kr(e, n) {
	return t(() => !!(e.prepend || e.append || n.value.options?.prepend || n.value.options?.append));
}
function qr(e, t) {
	return e.type === "object" || e.type === "array" && !(Ut(e) && e.items.enum) && !e.enum && !(q(t, "tags") && t.options.tags?.enabled) && !(Ut(e) && e.items.type === "string" && e.items.format === "uri" && t.options?.displayAsSingleUploadField);
}
function Jr(e, n) {
	return t(() => qr(e.value, n.value));
}
//#endregion
//#region src/renderings/renderHelpers/StringControl.ts
var Yr = /* @__PURE__ */ V({
	getIsMultiLine: () => Zr,
	getNumberOfLines: () => Qr,
	getType: () => Xr
});
function Xr(e, n) {
	return t(() => {
		let t = n.value.options?.format || e.value.format?.replace("date-time", "datetime-local");
		if (qt(t)) return t;
	});
}
function Zr(e) {
	return t(() => {
		let t = e.value.options?.multi;
		return typeof t == "number" ? t > 1 : !!t;
	});
}
function Qr(e) {
	return t(() => {
		let t = e.value.options?.multi;
		if (typeof t == "number") return t;
	});
}
//#endregion
//#region src/renderings/renderHelpers/SelectControl.ts
var $r = /* @__PURE__ */ V({
	createInvalidValueWatch: () => ti,
	getOptions: () => ei
});
function ei(e, n) {
	return t(() => e.value.enum ? q(n.value, "enumTitles") ? e.value.enum.map((e) => typeof e != "string" && typeof e != "number" ? e : {
		value: e,
		text: (n.value.options?.enumTitles)[e] || e
	}) : e.value.enum : []);
}
function ti(e, t, n) {
	M(() => e.value.enum, () => {
		e.value.enum && !e.value.enum.includes(t.value[n]) && (t.value[n] = void 0);
	});
}
//#endregion
//#region src/renderings/renderHelpers/CheckboxGroupControl.ts
var ni = /* @__PURE__ */ V({
	getOptions: () => ri,
	setupValuesAndValidation: () => ai
});
function ri(e, n) {
	return t(() => Gt(e.value) && e.value.items.enum.map((e) => {
		let t = G(n.value, "enumTitles", {})[e] || e;
		return {
			value: e,
			text: String(t)
		};
	}) || []);
}
function ii(e, n) {
	let r = S(!0), { jsonElement: i, savePath: a } = J(), { formDataStore: o, formStructureStore: s } = X(), { formData: c } = B(o), { formStateWasValidated: l } = B(s), d = u(U), f = () => {
		r.value = Lr(n, e.value, i.value, a, d);
	};
	return M(e, (e) => {
		f(), Gt(i.value) && (c.value[a] = i.value.items.enum.filter((t) => e.includes(t)));
	}), ee(f), t(() => {
		if (l.value) return r.value;
	});
}
function ai(e) {
	let { formDataStore: t } = X(), { formData: n } = B(t), r = S([]), { savePath: i } = J();
	return M(() => n.value[i], (e) => {
		let t;
		on(e) && Array.isArray(e) && (t = e?.map((e) => ct(e) ? n.value[lt(i, e)] : e), JSON.stringify(t) !== JSON.stringify(r.value) && (r.value = t));
	}, { immediate: !0 }), {
		values: r,
		state: ii(r, e)
	};
}
//#endregion
//#region src/renderings/renderHelpers/Button.ts
var oi = /* @__PURE__ */ V({
	getHtmlButtonType: () => si,
	getMaxPages: () => ci,
	getWizardHandler: () => li
});
function si(e) {
	return t(() => {
		if ([
			"submit",
			"reset",
			"button"
		].includes(e.buttonType)) return e.buttonType;
	});
}
function ci(e) {
	return t(() => e.value?.type === "Wizard" ? e.value.pages.length - 1 : 2 ** 53 - 1);
}
function li(e, t, n, r, i) {
	return () => {
		if (e.buttonType === "previousWizardPage") t.value = Math.max(t.value - 1, 0);
		else if (e.buttonType === "nextWizardPage") {
			if (n.value[t.value]?.()) r.value = !1;
			else return;
			t.value = Math.min(t.value + 1, i.value);
		}
	};
}
//#endregion
//#region src/renderings/renderHelpers/index.ts
var ui = /* @__PURE__ */ V({
	Base64String: () => $,
	Button: () => oi,
	CheckboxGroupControl: () => ni,
	FileControl: () => Rr,
	FormWrap: () => Tr,
	FormfieldWrapper: () => Gr,
	NumberControl: () => Ln,
	ProviderKeys: () => qe,
	SelectControl: () => $r,
	StringControl: () => Yr,
	arrayContainsValue: () => Tn,
	cleanScope: () => Y,
	computedCssClass: () => Q,
	computedLabel: () => En,
	controlID: () => Z,
	getComputedGrandparentJsonPath: () => bn,
	getComputedJsonElement: () => Cn,
	getComputedRequired: () => xn,
	getHtmlMessages: () => Dt,
	getJsonPointerSafe: () => yn,
	getOption: () => G,
	getRandomId: () => Dn,
	getStores: () => X,
	injectJsonData: () => J,
	isArray: () => wn
}), di = /* @__PURE__ */ l({
	__name: "CheckboxGroupControl",
	props: { required: { type: Boolean } },
	setup(e) {
		let t = e, { jsonElement: r, layoutElement: i, savePath: a } = J(), o = Z(a), s = ri(r, i), { values: c, state: l } = ai(t.required ?? !1);
		return (e, t) => (b(), n(k(ne), {
			id: k(o),
			modelValue: k(c),
			"onUpdate:modelValue": t[0] ||= (e) => d(c) ? c.value = e : null,
			options: k(s),
			class: "vjf_checkboxGroup",
			required: !1,
			state: k(l),
			stacked: k(G)(k(i), "stacked"),
			buttons: k(G)(k(i), "displayAs") === "buttons",
			switches: k(G)(k(i), "displayAs") === "switches",
			"button-variant": k(G)(k(i), "buttonVariant") || "primary"
		}, null, 8, [
			"id",
			"modelValue",
			"options",
			"state",
			"stacked",
			"buttons",
			"switches",
			"button-variant"
		]));
	}
}), fi = /*#__PURE__*/ H(/* @__PURE__ */ l({
	__name: "RadiobuttonControl",
	setup(e) {
		let { formDataStore: t } = X(), { formData: r } = B(t), { jsonElement: i, layoutElement: a, savePath: o } = J(), s = Z(o), c = ei(i, a);
		return ti(i, r, o), (e, t) => (b(), n(k(oe), {
			id: k(s),
			modelValue: k(r)[k(o)],
			"onUpdate:modelValue": t[0] ||= (e) => k(r)[k(o)] = e,
			options: k(c),
			class: "vjf_radioGroup w-100",
			buttons: k(G)(k(a), "displayAs") === "buttons",
			"button-variant": k(G)(k(a), "buttonVariant") || "primary",
			stacked: k(G)(k(a), "stacked")
		}, null, 8, [
			"id",
			"modelValue",
			"options",
			"buttons",
			"button-variant",
			"stacked"
		]));
	}
}), [["__scopeId", "data-v-4741ee0c"]]), pi = /* @__PURE__ */ l({
	__name: "SelectControl",
	setup(e) {
		let { formDataStore: t } = X(), { formData: r } = B(t), { jsonElement: i, layoutElement: a, savePath: o } = J(), s = Z(o), c = ei(i, a);
		return ti(i, r, o), (e, t) => (b(), n(k(se), {
			id: k(s),
			modelValue: k(r)[k(o)],
			"onUpdate:modelValue": t[0] ||= (e) => k(r)[k(o)] = e,
			options: k(c),
			class: "vjf_select",
			autocomplete: k(G)(k(a), "autocomplete", "on")
		}, null, 8, [
			"id",
			"modelValue",
			"options",
			"autocomplete"
		]));
	}
}), mi = /* @__PURE__ */ l({
	__name: "StringControl",
	setup(e) {
		let { formDataStore: t } = X(), { formData: r } = B(t), { jsonElement: i, layoutElement: a, savePath: o } = J(), s = Z(o), c = Xr(i, a), l = Zr(a), u = Qr(a);
		return (e, t) => k(l) ? (b(), n(k(le), {
			key: 0,
			id: k(s),
			modelValue: k(r)[k(o)],
			"onUpdate:modelValue": t[0] ||= (e) => k(r)[k(o)] = e,
			class: "vjf_textarea",
			rows: k(u),
			minlength: k(i).minLength,
			maxlength: k(i).maxLength,
			autocomplete: k(G)(k(a), "autocomplete", "on")
		}, null, 8, [
			"id",
			"modelValue",
			"rows",
			"minlength",
			"maxlength",
			"autocomplete"
		])) : (b(), n(k(ae), {
			key: 1,
			id: k(s),
			modelValue: k(r)[k(o)],
			"onUpdate:modelValue": t[1] ||= (e) => k(r)[k(o)] = e,
			class: "vjf_input",
			minlength: k(i).minLength,
			maxlength: k(i).maxLength,
			step: k(i).multipleOf,
			min: k(i).minimum,
			max: k(i).maximum,
			type: k(c),
			pattern: k(i).pattern,
			autocomplete: k(G)(k(a), "autocomplete", "on")
		}, null, 8, [
			"id",
			"modelValue",
			"minlength",
			"maxlength",
			"step",
			"min",
			"max",
			"type",
			"pattern",
			"autocomplete"
		]));
	}
}), hi = { key: 1 }, gi = /* @__PURE__ */ l({
	__name: "FormFieldWrapper",
	props: {
		label: {},
		labelFor: {}
	},
	setup(e) {
		let o = e, l = A(), { jsonElement: u, layoutElement: d } = J(), f = Jr(u, d), p = Kr(l, d), m = t(() => u.value.type === "boolean" || d.value.options?.label === !1 || f.value);
		return (e, t) => (b(), n(k(ie), {
			"label-for": o.labelFor,
			description: k(f) ? void 0 : k(u).description
		}, {
			label: N(() => [P(a("span", null, [s(E(o.label) + " ", 1), c(On)], 512), [[j, !m.value]])]),
			default: N(() => [k(p) ? (b(), n(k(ue), { key: 0 }, {
				default: N(() => [
					w(e.$slots, "prepend", {}, () => [k(d).options?.prepend ? (b(), n(k(de), { key: 0 }, {
						default: N(() => [s(E(k(d).options.prepend), 1)]),
						_: 1
					})) : r("", !0)]),
					w(e.$slots, "default"),
					w(e.$slots, "append", {}, () => [k(d).options?.append ? (b(), n(k(de), { key: 0 }, {
						default: N(() => [s(E(k(d).options.append), 1)]),
						_: 1
					})) : r("", !0)])
				]),
				_: 3
			})) : (b(), i("div", hi, [w(e.$slots, "default")]))]),
			_: 3
		}, 8, ["label-for", "description"]));
	}
}), _i = { key: 0 }, vi = { key: 1 }, yi = /* @__PURE__ */ l({
	__name: "VJFButton",
	props: {
		layoutElement: {},
		waiting: { type: Boolean }
	},
	setup(e) {
		let { formStructureStore: t } = X(), r = e, { currentWizardPage: a, uiSchema: o, wizardValidateFunctions: s, formStateWasValidated: l } = B(t), u = Q(r.layoutElement), d = si(r.layoutElement), f = ci(o), p = li(r.layoutElement, a, s, l, f);
		return (t, r) => (b(), n(k(I), {
			variant: e.layoutElement.options?.variant,
			type: k(d),
			class: h(k(u)),
			disabled: e.layoutElement.options?.disabled,
			onClick: k(p)
		}, {
			default: N(() => [e.waiting ? (b(), i("span", vi, [c(k(me), { small: "" })])) : (b(), i("span", _i, E(e.layoutElement.text), 1))]),
			_: 1
		}, 8, [
			"variant",
			"type",
			"class",
			"disabled",
			"onClick"
		]));
	}
}), bi = /*#__PURE__*/ H(/* @__PURE__ */ l({
	__name: "FileControl",
	props: {
		required: { type: Boolean },
		placeholder: {}
	},
	setup(e) {
		let t = e, { jsonElement: r, layoutElement: i, savePath: a } = J(), o = Z(a), s = u(U), c = u(et), l = Ur(i, a), f = zr(r), p = Hr(l), { file: m, state: g } = Wr(t.required ?? !1);
		return (r, i) => (b(), n(k(re), {
			id: k(o),
			modelValue: k(m),
			"onUpdate:modelValue": i[0] ||= (e) => d(m) ? m.value = e : null,
			state: k(g),
			class: h({
				vjf_file: !0,
				noBorderRadius: k(c)
			}),
			multiple: k(f),
			accept: k(p),
			required: e.required,
			"browse-text": k(s)?.getString("controls.upload.browse"),
			"drop-placeholder": k(s)?.getString("controls.upload.dropFilesHere"),
			placeholder: t.placeholder ?? k(s)?.getString("controls.upload.noFileChosen")
		}, null, 8, [
			"id",
			"modelValue",
			"state",
			"class",
			"multiple",
			"accept",
			"required",
			"browse-text",
			"drop-placeholder",
			"placeholder"
		]));
	}
}), [["__scopeId", "data-v-864ee8ab"]]), xi = { class: "vjf_modal_control" }, Si = {
	showOnWrapper: Re,
	CheckboxControl: kn,
	CheckboxGroupControl: di,
	FileControl: bi,
	NumberControl: Vn,
	ObjectControl: jr,
	RadiobuttonControl: fi,
	SelectControl: pi,
	StringControl: mi,
	TagsControl: Mr,
	FormFieldWrapper: gi,
	ErrorViewer: An,
	Button: yi,
	Buttongroup: Pn,
	HelpPopover: On,
	DefaultControl: Mn,
	ArrayButton: Ie,
	WizardProgress: Ke,
	Modal: /* @__PURE__ */ H(/* @__PURE__ */ l({
		__name: "Modal",
		props: { layoutElement: {} },
		setup(e) {
			let a = e, o = S(!1), l = t(() => {
				switch (a.layoutElement.modal.size) {
					case "small": return "sm";
					case "large": return "lg";
					case "x-large": return "xl";
					default: return;
				}
			}), d = t(() => ({
				type: "HTML",
				htmlData: a.layoutElement.modal.content
			})), f = u(U), p = t(() => Dt(a.layoutElement));
			return (t, a) => (b(), i("div", xi, [
				p.value.pre ? (b(), n(Un, {
					key: 0,
					"layout-element": p.value.pre
				}, null, 8, ["layout-element"])) : r("", !0),
				c(k(I), {
					variant: e.layoutElement.button.variant || "info",
					onClick: a[0] ||= (e) => o.value = !0
				}, {
					default: N(() => [s(E(e.layoutElement.button.text), 1)]),
					_: 1
				}, 8, ["variant"]),
				p.value.post ? (b(), n(Un, {
					key: 1,
					"layout-element": p.value.post
				}, null, 8, ["layout-element"])) : r("", !0),
				c(k(fe), {
					modelValue: o.value,
					"onUpdate:modelValue": a[2] ||= (e) => o.value = e,
					size: l.value,
					centered: "",
					scrollable: "",
					title: e.layoutElement.modal.title,
					class: "vjf_modal"
				}, {
					footer: N(() => [c(k(I), {
						variant: "primary",
						class: "w-100",
						onClick: a[1] ||= (e) => o.value = !1
					}, {
						default: N(() => [s(E(k(f)?.getString("buttons.close") || "Close"), 1)]),
						_: 1
					})]),
					default: N(() => [c(Un, { "layout-element": d.value }, null, 8, ["layout-element"])]),
					_: 1
				}, 8, [
					"modelValue",
					"size",
					"title"
				])
			]));
		}
	}), [["__scopeId", "data-v-88b6fd51"]]),
	ConfirmationModal: /* @__PURE__ */ l({
		__name: "ConfirmationModal",
		props: {
			title: {},
			confirmButtonText: {},
			cancelButtonText: {},
			hideCancelButton: { type: Boolean },
			confirmButtonVariant: {},
			cancelButtonVariant: {}
		},
		emits: ["confirm", "cancel"],
		setup(e, { expose: t, emit: r }) {
			let i = e, a = r, o = te("modal");
			return t({ show: () => {
				o.value?.show();
			} }), (e, t) => (b(), n(k(fe), {
				ref_key: "modal",
				ref: o,
				centered: "",
				title: i.title,
				"ok-title": i.confirmButtonText,
				"ok-variant": i.confirmButtonVariant,
				"cancel-title": i.cancelButtonText,
				"cancel-variant": i.cancelButtonVariant,
				"ok-only": i.hideCancelButton,
				onOk: t[0] ||= (e) => a("confirm"),
				onCancel: t[1] ||= (e) => a("cancel")
			}, {
				default: N(() => [w(e.$slots, "default")]),
				_: 3
			}, 8, [
				"title",
				"ok-title",
				"ok-variant",
				"cancel-title",
				"cancel-variant",
				"ok-only"
			]));
		}
	})
}, Ci = /* @__PURE__ */ l({
	__name: "ValidationError",
	props: { error: {} },
	setup(e) {
		let t = X().formStructureStore.getComponent("ErrorViewer");
		return (r, i) => (b(), n(T(k(t)), {
			header: e.error.title,
			class: "mb-3"
		}, {
			default: N(() => [
				a("p", null, [
					i[0] ||= s(" Error in element ", -1),
					a("code", null, E(e.error.path), 1),
					i[1] ||= s(": ", -1)
				]),
				a("p", null, E(e.error.message), 1),
				i[2] ||= a("hr", null, null, -1),
				a("pre", null, E(JSON.stringify(e.error.internalError, null, 2)), 1)
			]),
			_: 1
		}, 8, ["header"]));
	}
}), wi = /* @__PURE__ */ l({
	__name: "ParsingError",
	props: { error: {} },
	setup(e) {
		let t = X().formStructureStore.getComponent("ErrorViewer");
		return (r, i) => (b(), n(T(k(t)), {
			header: e.error.name,
			class: "mb-3"
		}, {
			default: N(() => [a("p", null, E(e.error.message), 1)]),
			_: 1
		}, 8, ["header"]));
	}
}), Ti = { key: 0 }, Ei = { key: 1 }, Di = { key: 2 }, Oi = { key: 3 }, ki = {
	key: 4,
	class: "mt-4"
}, Ai = { key: 5 }, ji = { key: 6 }, Mi = /* @__PURE__ */ l({
	__name: "ParsingAndValidationErrorsView",
	props: { validationErrors: {} },
	setup(o) {
		let s = o, c = t(() => !!(s.validationErrors.jsonSchema.parsing.length + s.validationErrors.jsonSchema.validation.length)), l = t(() => !!(s.validationErrors.uiSchema.parsing.length + s.validationErrors.uiSchema.validation.length));
		return (t, s) => (b(), i(e, null, [
			s[5] ||= a("h4", null, "Error", -1),
			s[6] ||= a("p", null, "There were errors while rendering this form", -1),
			o.validationErrors.general.length ? (b(), i("div", Ti, [s[0] ||= a("h5", null, "General", -1), (b(!0), i(e, null, C(o.validationErrors.general, (e) => (b(), n(wi, {
				key: e.message,
				error: e
			}, null, 8, ["error"]))), 128))])) : r("", !0),
			c.value ? (b(), i("h5", Ei, "JSON Schema")) : r("", !0),
			o.validationErrors.jsonSchema.parsing.length > 0 ? (b(), i("div", Di, [s[1] ||= a("h6", null, "Parsing errors", -1), (b(!0), i(e, null, C(o.validationErrors.jsonSchema.parsing, (e) => (b(), n(wi, {
				key: e.message,
				error: e
			}, null, 8, ["error"]))), 128))])) : r("", !0),
			o.validationErrors.jsonSchema.validation.length > 0 ? (b(), i("div", Oi, [s[2] ||= a("h6", null, "Validation errors", -1), (b(!0), i(e, null, C(o.validationErrors.jsonSchema.validation, (e) => (b(), n(Ci, {
				key: e.message + e.path,
				error: e
			}, null, 8, ["error"]))), 128))])) : r("", !0),
			l.value ? (b(), i("h5", ki, "UI Schema")) : r("", !0),
			o.validationErrors.uiSchema.parsing.length > 0 ? (b(), i("div", Ai, [s[3] ||= a("h6", null, "Parsing errors", -1), (b(!0), i(e, null, C(o.validationErrors.uiSchema.parsing, (e) => (b(), n(wi, {
				key: e.message,
				error: e
			}, null, 8, ["error"]))), 128))])) : r("", !0),
			o.validationErrors.uiSchema.validation.length > 0 ? (b(), i("div", ji, [s[4] ||= a("h6", null, "Validation errors", -1), (b(!0), i(e, null, C(o.validationErrors.uiSchema.validation, (e) => (b(), n(Ci, {
				key: e.message + e.path,
				error: e
			}, null, 8, ["error"]))), 128))])) : r("", !0)
		], 64));
	}
}), Ni = {
	errors: {
		fileUpload: {
			tooManyFiles: "Sie können nur !&data&! Dateien hochladen.",
			onlyOne: "Sie können nur eine Datei hochladen.",
			tooFewFiles: "Sie müssen mindestens !&data&! Dateien hochladen.",
			atLeastOne: "Sie müssen mindestens eine Datei hochladen.",
			fileTooLarge: "Die folgenden Dateien überschreiten die Dateigrößenbeschränkung von !&data&! MB: !&data&!"
		},
		checkboxGroup: {
			selectAtLeastOne: "Bitte wählen Sie mindestens eine Option aus.",
			selectAtMostOne: "Bitte wählen Sie höchstens eine Option aus.",
			selectAtLeast: "Bitte wählen Sie mindestens !&data&! Optionen aus.",
			selectAtMost: "Bitte wählen Sie höchstens !&data&! Optionen aus."
		},
		number: {
			invalidNumber: "Bitte geben Sie eine gültige Zahl ein.",
			tooSmall: "Die Zahl muss mindestens !&data&! betragen.",
			tooLarge: "Die Zahl darf maximal !&data&! betragen.",
			multipleOf: "Die Zahl muss ein Vielfaches von !&data&! sein."
		},
		generic: {
			errorOccurred: "Ein Fehler ist aufgetreten:",
			retryLater: "Bitte versuchen Sie es später erneut.",
			temporaryError: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut."
		}
	},
	buttons: {
		previous: "Zurück",
		next: "Weiter",
		close: "Schließen",
		save: "Speichern",
		clipboard: "In Zwischenablage kopieren",
		feedback: "Feedback"
	},
	controls: { upload: {
		browse: "Durchsuchen",
		noFileChosen: "Keine Datei ausgewählt",
		dropFilesHere: "Dateien hierher ziehen, um sie hochzuladen"
	} },
	modals: {
		"delete-remaining-items": {
			title: "Löschen der übrigen Elemente",
			text: "Da dieses Array mindestens !&data&! Elemente erfordert, werden alle übrigen Elemente aus dem Array gelöscht. Sind Sie sicher?",
			confirm: "Löschen",
			cancel: "Abbrechen"
		},
		summary: {
			title: "Zusammenfassung",
			saveTitle: "Titel",
			saveInstruction: "Setzen Sie einen Titel für die generierte Seite:"
		}
	}
}, Pi = {
	errors: {
		fileUpload: {
			tooManyFiles: "You can only upload !&data&! files.",
			onlyOne: "You can only upload one file.",
			tooFewFiles: "You need to upload at least !&data&! files.",
			atLeastOne: "You need to upload at least one file.",
			fileTooLarge: "The following files exceed the file size limit of !&data&! MB: !&data&!"
		},
		checkboxGroup: {
			selectAtLeastOne: "Please select at least one option.",
			selectAtMostOne: "Please select at most one option.",
			selectAtLeast: "Please select at least !&data&! options.",
			selectAtMost: "Please select at most !&data&! options."
		},
		number: {
			invalidNumber: "Please enter a valid number.",
			tooSmall: "The number must be at least !&data&!",
			tooLarge: "The number must be at most !&data&!",
			multipleOf: "The number must be a multiple of !&data&!"
		},
		generic: {
			errorOccurred: "An error occurred:",
			retryLater: "Please try again later.",
			temporaryError: "An error occurred. Please try again later."
		}
	},
	buttons: {
		previous: "Previous",
		next: "Next",
		close: "Close",
		save: "Save",
		clipboard: "Copy to clipboard",
		feedback: "Feedback"
	},
	controls: { upload: {
		browse: "Browse",
		noFileChosen: "No file chosen",
		dropFilesHere: "Drop files here to upload"
	} },
	modals: {
		"delete-remaining-items": {
			title: "Delete the remaining items",
			text: "Since this array requires at least !&data&! items, this will delete all remaining items from the array. Are you sure?",
			confirm: "Delete",
			cancel: "Cancel"
		},
		summary: {
			title: "Summary",
			saveTitle: "Title",
			saveInstruction: "Choose a title for the generated page:"
		}
	}
};
//#endregion
//#region src/intl/LanguageProvider.ts
function Fi(e) {
	return typeof e == "object" && !!e && !Array.isArray(e);
}
var Ii = class {
	getStringTemplate(e, ...t) {
		let n = this.getString(e);
		return (n.match(/!&data&!/g) || []).forEach((e, r) => {
			n = n.replace(/!&data&!/, t[r]?.toString() || "");
		}), n;
	}
}, Li = class extends Ii {
	getString(e) {
		let t = this.data;
		for (let n of e.split(".")) {
			if (!Fi(t)) return e;
			t = t[n];
		}
		return typeof t == "string" ? t : e;
	}
}, Ri = class extends Li {
	data = Ni;
}, zi = class extends Li {
	data = Pi;
}, Bi = class extends Ii {
	provider;
	constructor() {
		super(), (navigator.language || "en").startsWith("de") ? this.provider = new Ri() : this.provider = new zi();
	}
	getString(e) {
		return this.provider.getString(e);
	}
}, Vi = /* @__PURE__ */ l({
	__name: "WizardPage",
	props: {
		page: {},
		pageName: {},
		index: {}
	},
	setup(t) {
		let n = t, r = Dn();
		function o() {
			let e = [...document.getElementById(r)?.querySelectorAll("*") || []].filter(ln).map((e) => ({
				valid: e.checkValidity(),
				el: e
			}));
			return e.find((e) => !e.valid)?.el.reportValidity(), e.every((e) => e.valid);
		}
		let { formStructureStore: s } = X();
		return s.wizardValidateFunctions[n.index] = o, y(() => {
			delete s.wizardValidateFunctions[n.index];
		}), (n, o) => (b(), i(e, null, [a("h2", null, E(t.pageName), 1), c(Tr, {
			id: k(r),
			"layout-element": t.page
		}, null, 8, ["id", "layout-element"])], 64));
	}
}), Hi = { class: "pages-wrapper" }, Ui = /*#__PURE__*/ H(/* @__PURE__ */ l({
	__name: "Wizard",
	props: { wizardElement: {} },
	setup(n) {
		let { formStructureStore: r } = X(), o = r.getComponent("WizardProgress"), s = n, { currentWizardPage: l } = B(r), u = t(() => s.wizardElement.pages.map((e, t) => t === l.value));
		return (t, r) => (b(), i(e, null, [
			c(k(o), {
				"current-step": k(l),
				"onUpdate:currentStep": r[0] ||= (e) => d(l) ? l.value = e : null,
				"number-of-pages": n.wizardElement.pages.length,
				"page-names": n.wizardElement.options?.pageTitles
			}, null, 8, [
				"current-step",
				"number-of-pages",
				"page-names"
			]),
			r[1] ||= a("hr", null, null, -1),
			a("div", Hi, [(b(!0), i(e, null, C(n.wizardElement.pages, (e, t) => (b(), i("div", { key: "wizard-page-" + t }, [P(a("div", null, [c(Vi, {
				page: e,
				"page-name": n.wizardElement.options?.pageTitles?.[t],
				index: t
			}, null, 8, [
				"page",
				"page-name",
				"index"
			])], 512), [[j, u.value[t]]])]))), 128))])
		], 64));
	}
}), [["__scopeId", "data-v-3d4da782"]]), Wi = ["id"], Gi = /* @__PURE__ */ l({
	__name: "FormRoot",
	props: {
		onSubmitForm: { type: Function },
		jsonSchema: {},
		uiSchema: {},
		renderInterface: {},
		presetData: {},
		generationOptions: {},
		returnDataAsScopes: { type: Boolean },
		mappers: {},
		hideValidationState: { type: Boolean },
		validator: { type: Function },
		languageProvider: {},
		formId: {}
	},
	setup(e) {
		let a = e, o = a.formId ?? st();
		x(Je, o), ve(_e() || he()), x($e, {}), x(U, a.languageProvider || new Bi());
		let { formStructureStore: s, formDataStore: c } = X(o), { jsonSchema: l, uiSchema: u, mappers: d, components: p, defaultData: m, buttonWaiting: g, formStateWasValidated: v } = B(s), { formData: ee, defaultFormData: y, cleanedFormData: C } = B(c), T = S({
			general: [],
			jsonSchema: {
				validation: [],
				parsing: []
			},
			uiSchema: {
				validation: [],
				parsing: []
			}
		}), E = t(() => a.validator ? new a.validator() : new xe()), O = t(() => {
			let e = "vjf_form";
			return v.value && !a.hideValidationState && (e += " was-validated"), e;
		});
		async function A(e) {
			e.preventDefault(), e.stopPropagation();
			let t = e, n;
			n = a.returnDataAsScopes ? D(C.value.scopes) : D(C.value.json);
			let r = JSON.parse(decodeURIComponent(t.submitter?.attributes?.getNamedItem("submit-options")?.value || "false")) || {};
			g.value[r.id] = !0;
			try {
				await a.onSubmitForm(n, r, t);
			} catch (e) {
				console.error("Failed to submit form"), console.error(e);
			} finally {
				g.value[r.id] = !1;
			}
		}
		function te() {
			y.value = {
				...ht(a.presetData || {}),
				...m.value
			};
		}
		function j() {
			ee.value = { ...y.value };
		}
		function N(e) {
			e.preventDefault(), j(), v.value = !1;
		}
		async function P(e) {
			return E.value.validateJsonSchema(e) ? e : (T.value.jsonSchema.validation = E.value.getJsonSchemaValidationErrors(), null);
		}
		async function F(e, t) {
			return e ? E.value.validateUiSchema(e) ? ot(e) ? e : (T.value.uiSchema.validation = [{
				title: "Invalid UI Schema Version",
				path: "/version",
				message: `Invalid UI Schema version '${e.version}' is incompatible with this parser's supported version '2.2'`
			}], null) : (T.value.uiSchema.validation = E.value.getUiSchemaValidationErrors(), null) : ft(t, a.generationOptions);
		}
		function I(e) {
			p.value = e ? f(e) : void 0;
		}
		async function L(e) {
			e.renderInterface && I(e.renderInterface), d.value = a.mappers || [];
			let t = await P(e.jsonSchema).catch((e) => {
				T.value.jsonSchema.parsing.push(e), console.error(e);
			});
			if (!t) return;
			l.value = t;
			let n = await F(e.uiSchema, t).catch((e) => {
				T.value.uiSchema.parsing.push(e), console.error(e);
			});
			n && (u.value = n.layout);
		}
		x(Xe, !0);
		async function R() {
			try {
				await E.value.initialize();
			} catch (e) {
				console.error("Failed to initialize validator"), console.error(e), e instanceof Error && (T.value.general = [e]);
			}
		}
		async function z() {
			await R(), await L({
				jsonSchema: a.jsonSchema,
				uiSchema: a.uiSchema,
				renderInterface: a.renderInterface
			}), te(), j();
		}
		return _(z), M([() => a.jsonSchema, () => a.uiSchema], z), M(E, R), M(() => a.renderInterface, (e) => {
			I(e);
		}), (e, t) => k(u) && k(l) ? (b(), i("form", {
			key: 0,
			id: k(o),
			class: h(O.value),
			autocomplete: "off",
			onSubmit: A,
			onReset: N,
			onInvalidCapture: t[0] ||= (e) => v.value = !0
		}, [k(cn)(k(u)) ? (b(), n(Tr, {
			key: 0,
			"layout-element": k(u)
		}, null, 8, ["layout-element"])) : k(sn)(k(u)) ? (b(), n(Ui, {
			key: 1,
			"wizard-element": k(u)
		}, null, 8, ["wizard-element"])) : r("", !0), w(e.$slots, "default")], 42, Wi)) : T.value.jsonSchema.parsing.length + T.value.jsonSchema.validation.length + T.value.uiSchema.parsing.length + T.value.uiSchema.validation.length + T.value.general.length > 0 ? (b(), n(Mi, {
			key: 1,
			"validation-errors": T.value
		}, null, 8, ["validation-errors"])) : r("", !0);
	}
}), Ki = "0.0.0";
//#endregion
export { Bi as AutoLanguageProvider, Pt as DependentRequiredMapper, zi as EnglishLanguageProvider, Ri as GermanLanguageProvider, Et as IfThenElseMapper, Li as JSONLanguageProvider, Ii as LanguageProvider, xt as Mapper, Ct as MapperWithData, St as MapperWithoutData, Tt as OneOfToEnumMapper, ui as RenderHelpers, Nt as RitaDependentOptionsMapper, Gi as VueJsonForm, an as allDefined, Si as bootstrapComponents, ft as generateUISchema, pt as getPropertyByString, Bt as hasCssClass, Rt as hasElements, Gt as hasEnumValuesForItems, Ut as hasItems, q as hasOption, K as hasProperty, rn as isDefined, Lt as isDependentElement, un as isElementWithCustomValidity, zt as isEnumButtonsConfig, Xt as isIfThenAllOf, Wt as isIndexType, Kt as isInputType, qt as isInputTypeWithoutHidden, Ft as isKeyOf, cn as isLayout, Vt as isLegacyShowOn, Yt as isMapperWithData, Jt as isMapperWithoutData, on as isNotNullOrUndefined, en as isSupportedIf, Zt as isSupportedIfCondition, nn as isSupportedIfThenElse, tn as isSupportedThenOrElse, Ht as isValidJsonSchemaKey, ln as isValidateableElement, sn as isWizard, at as supportedUiSchemaVersion, Lr as validateCheckboxGroupInput, Pr as validateFileInput, Ki as version };

//# sourceMappingURL=vue-json-form.js.map